/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull ampli_approved_event'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 105
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./implementation/ampli_approved_event)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'default';

export const ApiKey: Record<Environment, string> = {
  default: 'e77e0b640b2cbe43ff235bbf62d75947'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '105',
    branch: 'main',
    source: 'ampli_approved_event',
    versionId: '8f38049d-be44-4a8e-96fc-4d293be8fbea'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  /**
   * Name of the Customer Success Manager assigned to the matched Salesforce account.
   */
  account_csm?: string;
  /**
   * Whether the matched Salesforce account currently has an open opportunity.
   */
  account_has_open_opportunity?: boolean;
  /**
   * Account tier based on total enrollment across the full district hierarchy. Use for territory planning and market sizing.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Enterprise, MidMarket, Small Business, Self Serve/Digital, Strategic |
   */
  account_hierarchy_tier?: "Enterprise" | "MidMarket" | "Small Business" | "Self Serve/Digital" | "Strategic";
  /**
   * Type of educational institution associated with the Salesforce account.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | district, public school, private school, catholic school, state school, county school, county office, regional center, cmo, diocese, bia school, state dept, unknown |
   */
  account_institution_type?:
    | "district"
    | "public school"
    | "private school"
    | "catholic school"
    | "state school"
    | "county school"
    | "county office"
    | "regional center"
    | "cmo"
    | "diocese"
    | "bia school"
    | "state dept"
    | "unknown";
  /**
   * Date of the last logged Salesforce activity on the account (ISO 8601: YYYY-MM-DD). Use for identifying accounts with no recent sales touch.
   */
  account_last_activity_date?: string;
  /**
   * Salesforce account name matched to the user's email domain.
   */
  account_name?: string;
  /**
   * Name of the Account Executive who owns the matched Salesforce account.
   */
  account_owner?: string;
  /**
   * Current lifecycle phase of the Salesforce account.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | New, Activating, Onboarding, Adopting, Renewal, SAA, SQA, MQA, Advocacy, Recycle |
   */
  account_phase?:
    | "New"
    | "Activating"
    | "Onboarding"
    | "Adopting"
    | "Renewal"
    | "SAA"
    | "SQA"
    | "MQA"
    | "Advocacy"
    | "Recycle";
  /**
   * Name of the Regional Vice President responsible for the matched Salesforce account.
   */
  account_rvp?: string;
  /**
   * Sales territory region of the matched Salesforce account.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Northeast, Southeast, Central, West |
   */
  account_sales_region?: "Northeast" | "Southeast" | "Central" | "West";
  /**
   * Name of the Sales Development Rep assigned to the matched Salesforce account.
   */
  account_sdr?: string;
  /**
   * Level of CS engagement and treatment for the matched Salesforce account. Reflects CS coverage model, not account size.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Enterprise, MidMarket, Small Business, Self Serve/Digital, Strategic |
   */
  account_service_tier?: "Enterprise" | "MidMarket" | "Small Business" | "Self Serve/Digital" | "Strategic";
  /**
   * Salesforce account status — whether the account is a current customer or prospect.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Customer, Prospect, Former Customer, Pilot |
   */
  account_status?: "Customer" | "Prospect" | "Former Customer" | "Pilot";
  /**
   * Whether the user has completed the activation milestone (first meaningful generation).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Initiated, Activated |
   */
  activation_stage?: "Initiated" | "Activated";
  authentication_provider?: string;
  community?: string;
  created_at?: string;
  /**
   * Subject area or department inferred from the user's profile.
   */
  department?: string;
  /**
   * MDR student enrollment count for the matched district (source of truth for district size).
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  district_account_enrollment?: number;
  /**
   * Salesforce ID of the district account matched to this user.
   */
  district_account_id?: string;
  /**
   * Name of the district Salesforce account matched to this user.
   */
  district_account_name?: string;
  /**
   * Whether the user signed up with a work or personal email domain.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | work, personal |
   */
  domain_type?: "work" | "personal";
  /**
   * Classification of the user's email address (e.g. personal, work, edu).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | work, personal |
   */
  email_type?: "work" | "personal";
  /**
   * Usage-based engagement tier computed from generation activity. None = registered but never generated. Power/Core = highest engagement.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | None, Infrequent, Casual, Core, Power |
   */
  engagement_status?: "None" | "Infrequent" | "Casual" | "Core" | "Power";
  /**
   * Facebook Click ID. Set on the user's last touch when a visitor arrives via a Facebook or Instagram Ads click. Used for Meta attribution and conversion matching. Populated by GTM on the marketing site. See also: initial_fbclid (first-touch).
   */
  fbclid?: string;
  /**
   * Date the user ran their first AI generation (ISO 8601: YYYY-MM-DD). Use as cohort anchor and user tenure reference.
   */
  first_generation_date?: string;
  /**
   * Google Click ID for app conversions (iOS, privacy-safe). Set on the user's last touch when a visitor arrives via a Google Ads click on iOS with SKAdNetwork attribution. Used alongside gclid for Google paid search attribution. The derived property has_paid_search_click_id is true when this or gclid, msclkid, or wbraid is set. See also: initial_gbraid (first-touch).
   */
  gbraid?: string;
  /**
   * Google Click ID. Set on the user's last touch when a visitor arrives via a Google Ads click. Used to attribute sessions to Google paid search campaigns. Populated by GTM on the marketing site. The derived property has_paid_search_click_id is true when this or msclkid, gbraid, or wbraid is set. See also: initial_gclid (first-touch).
   */
  gclid?: string;
  /**
   * Grade level band the user primarily teaches.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | PK, K-5, 6-8, 9-12, K-8, K-12, 6-12 |
   */
  grade_band?: "PK" | "K-5" | "6-8" | "9-12" | "K-8" | "K-12" | "6-12";
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  grades?: string[];
  /**
   * First-touch Kochava Click ID. Set once on the user's first marketing touchpoint when they arrive via a Kochava-tracked link. Used to attribute the user's acquisition to programmatic or affiliate campaigns tracked through Kochava. The derived property has_programmatic_click_id is true when this is set. Not overwritten on subsequent visits.
   */
  initial_ko_click_id?: string;
  /**
   * Whether the user's Salesforce account has an active Educator Guidance product in its CW Opportunity Products rollup (Salesforce `EG_Included_in_Active_CW_Opp_Products__c`). `true`/`false` when the user has a matched Salesforce account; absent (no value) when the user has no associated Salesforce account.
   */
  is_educator_guidance_purchased?: boolean;
  /**
   * Whether the user's organization has purchased the Learning Outcomes Module (LOM), based on the org-level `enable_lom_purchased` attribute in the product database. `true`/`false` when the user's org is known; absent (no value) when the user has no associated organization.
   */
  is_learning_outcomes_module_purchased?: boolean;
  /**
   * Whether the user's organization has MagicStudent enabled, based on the org-level `enable_magic_student` attribute in the product database. `true`/`false` when the user's org is known; absent (no value) when the user has no associated organization.
   */
  is_magicstudent_enabled?: boolean;
  /**
   * LinkedIn First-Party Ad Tracking ID. Set on the user's last touch when a visitor arrives via a LinkedIn Ads click. Used to attribute sessions to LinkedIn paid social campaigns. The derived property has_paid_social_click_id is true when this or ttclid or twclid is set. See also: initial_li_fat_id (first-touch).
   */
  li_fat_id?: string;
  /**
   * Monthly active user lifecycle status as of the last daily refresh.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new, retained, resurrected, churned |
   */
  mau_status?: "new" | "retained" | "resurrected" | "churned";
  /**
   * Salesforce contact membership type (e.g. Pioneer, Ambassador).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Pioneer, Ambassador |
   */
  member_type?: "Pioneer" | "Ambassador";
  /**
   * Microsoft (Bing) Click ID. Set on the user's last touch when a visitor arrives via a Microsoft Advertising (Bing Ads) click. Used to attribute sessions to Bing paid search campaigns. The derived property has_paid_search_click_id is true when this or gclid, gbraid, or wbraid is set. See also: initial_msclkid (first-touch).
   */
  msclkid?: string;
  /**
   * Name of the MagicSchool org the user currently belongs to.
   */
  org_name?: string;
  /**
   * Type of MagicSchool org the user belongs to.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | School, District, Organization, Group |
   */
  org_type?: "School" | "District" | "Organization" | "Group";
  /**
   * Role persona inferred from profession and title. Used for segmentation and targeting.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Educators, Principals, Instructional Leaders, School System Leads, Tech Leaders, Ed Tech Coordinators, Other |
   */
  persona?:
    | "Educators"
    | "Principals"
    | "Instructional Leaders"
    | "School System Leads"
    | "Tech Leaders"
    | "Ed Tech Coordinators"
    | "Other";
  /**
   * The user's current MagicSchool plan.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | free, partner, plus |
   */
  plan_name?: "free" | "partner" | "plus";
  /**
   * Seniority level inferred from title. Complements persona for TAM targeting.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Staff, Director, Specialist, Executive, Mid, Other |
   */
  rank?: "Staff" | "Director" | "Specialist" | "Executive" | "Mid" | "Other";
  /**
   * Reactivation funnel stage for previously churned users who have returned.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | None, Initiated, Activated |
   */
  reactivation_stage?: "None" | "Initiated" | "Activated";
  /**
   * City of the matched school.
   */
  school_city?: string;
  /**
   * Student enrollment at the matched school.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  school_enrollment?: number;
  /**
   * Grade-level classification of the matched school (e.g. elementary, middle, high).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | PK, K-5, 6-8, 9-12, K-8, K-12, 6-12, Higher Ed |
   */
  school_level?: "PK" | "K-5" | "6-8" | "9-12" | "K-8" | "K-12" | "6-12" | "Higher Ed";
  /**
   * Name of the school matched to the user via institution resolution.
   */
  school_name?: string;
  /**
   * Two-letter state code of the matched school.
   */
  school_state?: string;
  /**
   * Number of teachers at the matched school.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  school_teachers?: number;
  /**
   * Type of school (e.g. public, private, charter) from institution data.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | public_k12, private_k12, college |
   */
  school_type?: "public_k12" | "private_k12" | "college";
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  subjects?: string[];
  /**
   * All individual grade levels the user teaches (e.g. ['3','4','5']).
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  teacher_grades?: string[];
  /**
   * All subjects the user teaches (e.g. ['Math','Science/STEM']).
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  teacher_subjects?: string[];
  /**
   * TikTok Click ID. Set on the user's last touch when a visitor arrives via a TikTok Ads click. Used to attribute sessions to TikTok paid social campaigns. The derived property has_paid_social_click_id is true when this or li_fat_id or twclid is set. See also: initial_ttclid (first-touch).
   */
  ttclid?: string;
  /**
   * Twitter/X Click ID. Set on the user's last touch when a visitor arrives via a Twitter/X Ads click. Used to attribute sessions to Twitter/X paid social campaigns. The derived property has_paid_social_click_id is true when this or li_fat_id or ttclid is set. See also: initial_twclid (first-touch).
   */
  twclid?: string;
  /**
   * Registered email domain of the ultimate parent Salesforce account.
   */
  ultimate_parent_account_domain?: string;
  /**
   * Salesforce ID of the top-level account in the hierarchy (e.g. the state DOE or CMO).
   */
  ultimate_parent_account_id?: string;
  /**
   * Name of the top-level Salesforce account in the hierarchy.
   */
  ultimate_parent_account_name?: string;
  /**
   * Last-touch UTM campaign name. Identifies the specific campaign (e.g., back-to-school-2025, district-q3) from the user's most recent touchpoint. Set by GTM on the marketing site from the utm_campaign query parameter. Used for campaign-level performance reporting. See also: initial_utm_campaign (first-touch).
   */
  utm_campaign?: string;
  /**
   * Last-touch UTM content. Differentiates ads or links within the same campaign (e.g., banner-a, cta-blue). Used for A/B testing creative variants and link placement. Set by GTM on the marketing site from the utm_content query parameter. See also: initial_utm_content (first-touch).
   */
  utm_content?: string;
  /**
   * Last-touch UTM campaign ID. A numeric or alphanumeric identifier for the campaign, used to link Amplitude data back to ad platform campaign records. Set by GTM on the marketing site from the utm_id query parameter. See also: initial_utm_id (first-touch).
   */
  utm_id?: string;
  /**
   * Last-touch UTM medium. Identifies the marketing channel type (e.g., cpc, email, social) from the user's most recent touchpoint. Set by GTM on the marketing site from the utm_medium query parameter. Used alongside utm_source in the Marketing Channel classifier. See also: initial_utm_medium (first-touch).
   */
  utm_medium?: string;
  /**
   * Last-touch UTM source. Identifies the traffic source (e.g., google, facebook, beehiiv) from the user's most recent marketing touchpoint. Set by GTM on the marketing site from the utm_source query parameter. Used as the primary dimension in the Marketing Channel classifier. See also: initial_utm_source (first-touch).
   */
  utm_source?: string;
  /**
   * Last-touch UTM term. Captures the paid search keyword that triggered the ad click (e.g., ai lesson plan generator). Set by GTM on the marketing site from the utm_term query parameter. Primarily used for Google and Bing paid search keyword reporting. See also: initial_utm_term (first-touch).
   */
  utm_term?: string;
  /**
   * Google Click ID for web conversions (iOS, privacy-safe). Set on the user's last touch when a visitor arrives via a Google Ads click on iOS with web-to-app attribution. Used alongside gclid for Google paid search attribution. The derived property has_paid_search_click_id is true when this or gclid, msclkid, or gbraid is set. See also: initial_wbraid (first-touch).
   */
  wbraid?: string;
  "Words Generated"?: string;
}

export interface AiOutputSubmitFeedbackProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Type"?: string;
  /**
   * **where was the output collected**
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  aiOutputType: string;
  customizationId?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  feedback?: string;
  hasFlaggedWord?: any;
  isFlagged?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  messageId?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  percentageThreadsSummarized?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  quizAttemptId?: string;
  quizId?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  quizStatus?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  quizVersionId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  quizVersionQuestionId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  roomId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sentimentType?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  studentId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  threadId?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  toolId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
  user?: {
    authentication_provider?: string;
    best_practices_completed?: boolean;
    city?: string;
    confirmed_at?: string;
    country?: string;
    created_at?: string;
    custom_subject?: string;
    district?: string;
    email?: string;
    email_confirmed_at?: string;
    grades?: any[];
    id?: string;
    is_demo?: boolean;
    name?: string;
    nudge_test_serial_id?: number;
    onboarding_experience_variant2?: {
      [k: string]: any;
    };
    onboarding_experience_variant3?: string;
    org?: string;
    plan?: number;
    profile_status?: string;
    role?: string;
    school?: string;
    state?: string;
    status?: string;
    student_friendly_name?: string;
    subjects?: any[];
    updated_at?: string;
    user_role?: string;
  };
}

export interface AlertCategoryToggledProperties {
  /**
   * The moderation category being toggled (e.g. imminent_harm_to_self, violence_ideation_intent).
   */
  category?: string;
  /**
   * Whether the category was toggled on (true) or off (false).
   */
  enabled?: boolean;
  /**
   * The alertable moderation category an admin toggled email alerts for.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | imminent_harm_to_self, self_harm_non_imminent, imminent_harm_to_others, mental_emotional_distress, violent_ideation_intent |
   */
  moderation_category?:
    | "imminent_harm_to_self"
    | "self_harm_non_imminent"
    | "imminent_harm_to_others"
    | "mental_emotional_distress"
    | "violent_ideation_intent";
}

export interface AskUserQuestionAnsweredProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Which chat surface the stopped generation was running on.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | raina, tool, insights |
   */
  chat_surface: "raina" | "tool" | "insights";
  /**
   * 1-based position of the question within its set.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  question_index: number;
  /**
   * Number of offered options on the question, excluding write-in.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  question_options_count: number;
  /**
   * Options selected by the user in the AskUserQuestion tool card. Always 1 for single-select.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  question_options_selected_count: number;
  /**
   * Whether the question allows one selection or several.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | single_select, multi_select |
   */
  question_type: "single_select" | "multi_select";
  /**
   * Number of questions presented together in one set.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  round_questions_count: number;
  /**
   * Raina thread the message belongs to
   */
  thread_id: string;
  /**
   * ID of the AI tool call behind the experience. Joins events from the same tool call and is the dedupe key for impressions.
   */
  tool_call_id: string;
  /**
   * True if the answer used write-in text.
   */
  write_in_answer_used: boolean;
}

export interface AskUserQuestionSkippedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * How the askUserQuestion question came to be skipped.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | skip_button, skip_all, unanswered_at_submit |
   */
  ask_user_question_skip_method: "skip_button" | "skip_all" | "unanswered_at_submit";
  /**
   * Which chat surface the stopped generation was running on.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | raina, tool, insights |
   */
  chat_surface: "raina" | "tool" | "insights";
  /**
   * 1-based position of the question within its set.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  question_index: number;
  /**
   * Number of offered options on the question, excluding write-in.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  question_options_count: number;
  /**
   * Whether the question allows one selection or several.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | single_select, multi_select |
   */
  question_type: "single_select" | "multi_select";
  /**
   * Number of questions presented together in one set.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  round_questions_count: number;
  /**
   * Raina thread the message belongs to
   */
  thread_id: string;
  /**
   * ID of the AI tool call behind the experience. Joins events from the same tool call and is the dedupe key for impressions.
   */
  tool_call_id: string;
}

export interface AskUserQuestionsImpressionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Which chat surface the stopped generation was running on.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | raina, tool, insights |
   */
  chat_surface: "raina" | "tool" | "insights";
  /**
   * Number of questions in the set that allow multiple selections.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  multi_select_question_count: number;
  /**
   * Number of questions presented together in one set.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  round_questions_count: number;
  /**
   * Raina thread the message belongs to
   */
  thread_id: string;
  /**
   * ID of the AI tool call behind the experience. Joins events from the same tool call and is the dedupe key for impressions.
   */
  tool_call_id: string;
}

export interface AskUserQuestionsSubmittedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Number of questions in the set that were answered.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  answered_count: number;
  /**
   * How the askUserQuestion round was submitted.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | answered_last_question, skip_all, skipped_last_question |
   */
  ask_user_question_submit_method: "answered_last_question" | "skip_all" | "skipped_last_question";
  /**
   * Which chat surface the stopped generation was running on.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | raina, tool, insights |
   */
  chat_surface: "raina" | "tool" | "insights";
  /**
   * Number of questions presented together in one set.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  round_questions_count: number;
  /**
   * Number of questions in the set that were skipped.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  skipped_count: number;
  /**
   * Raina thread the message belongs to
   */
  thread_id: string;
  /**
   * ID of the AI tool call behind the experience. Joins events from the same tool call and is the dedupe key for impressions.
   */
  tool_call_id: string;
  /**
   * Number of answered questions in the set that used write-in text.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  write_in_answer_count: number;
}

export interface BlockInsertedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Which editor the event came from, so one event covers documents and decks.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | document, presentation |
   */
  artifact_type: "document" | "presentation";
  /**
   * What the teacher inserted.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | table, math, image, link |
   */
  block_type: "table" | "math" | "image" | "link";
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  editor_mode?: any;
  /**
   * How the block arrived: a toolbar insert button, or an image pasted from the clipboard.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | toolbar, paste |
   */
  insert_method: "toolbar" | "paste";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface BrandingImpressionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Describes the state of the module when the user sees it on the page.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | expanded, collapsed |
   */
  bulletin_board_panel_state: "expanded" | "collapsed";
  /**
   * Boolean to track if the welcome message has any url/link in the message.
   */
  has_links: boolean;
}

export interface BrandingLinkNavigatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The path of a url the user is (or will be) navigated to.
   */
  bulletin_board_link_destination: string;
  /**
   * A link has both `href` and `text`. "Display text" means the author gave the link a human-readable label rather than pasting the raw URL. If true, there is display text for the link.
   */
  bulletin_board_link_has_display_text: boolean;
  /**
   * Index of the link within a block of content.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  bulletin_board_link_index: number;
}

export interface BreadcrumbNavigatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * How many crumbs the trail had when it was clicked.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  crumb_count: number;
  /**
   * 1-based position of the clicked link crumb, counted from the root crumb.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  crumb_position: number;
  /**
   * True when the clicked crumb was not fully visible at click time: its text was ellipsized, or it was hidden behind the overflow menu.
   */
  was_truncated: boolean;
}

export interface ChatGenerationStoppedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Which chat surface the stopped generation was running on.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | raina, tool, insights |
   */
  chat_surface: "raina" | "tool" | "insights";
  /**
   * Milliseconds between sending the message and the user stopping it. On a turn the SDK auto-resumed after a tool call, this measures from the original send.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  elapsed_ms: number;
  /**
   * Whether any assistant content had rendered before the stop. False means the user saw nothing and the empty answer is discarded.
   */
  has_partial_content: boolean;
  /**
   * The user message that triggered the stopped generation. The assistant row is not written until the turn ends, so its id is never available to a stopped client. Empty on tool-output resends, where no new user message is created.
   */
  message_id: string;
  /**
   * Underlying LLM Model that was running when the user stopped it.
   */
  model_used: string;
  /**
   * Whether the stopped generation was the thread's initial output or a later refinement. Derived from the message count the same way the generation lifecycle events derive it.
   */
  source: string;
  /**
   * Raina thread the stopped generation belongs to.
   */
  thread_id: string;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations). On the raina surface this is the Raina slug.
   */
  tool_slug: string;
  /**
   * Whether web search was enabled on the request that was stopped.
   */
  web_search_enabled: boolean;
}

export interface ChatMessageSubmittedProperties {
  /**
   * Which chat surface fired the send, same values as the Tool Suggestion events.
   */
  chat_surface: string;
  /**
   * Client message id for joining the send to the assistant response; empty until the server assigns one.
   */
  message_id?: string;
  /**
   * Assistant thread id the message belongs to; joins to Braintrust metadata.threadId and BigQuery public_assistant_threads.id.
   */
  thread_id?: string;
}

export interface ContentCopiedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Which editor the event came from, so one event covers documents and decks.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | document, presentation |
   */
  artifact_type: "document" | "presentation";
  /**
   * What the copied selection held.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | text, table, image, figure, mixed |
   */
  copy_content_type: "text" | "table" | "image" | "figure" | "mixed";
  /**
   * Whether the selection was copied or cut.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | copy, cut |
   */
  copy_method: "copy" | "cut";
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  editor_mode?: any;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface ContentFormattedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Which editor the event came from, so one event covers documents and decks.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | document, presentation |
   */
  artifact_type: "document" | "presentation";
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id?: string;
  editor_mode?: any;
  /**
   * The formatting control the teacher used. text_style, strikethrough, blank and equation are slide-only; heading, font, size, colour, highlight, list and indent are document-only.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | heading, text_style, font_family, font_size, bold, italic, underline, strikethrough, text_color, highlight, alignment, list, indent, blank, equation |
   */
  formatting_control:
    | "heading"
    | "text_style"
    | "font_family"
    | "font_size"
    | "bold"
    | "italic"
    | "underline"
    | "strikethrough"
    | "text_color"
    | "highlight"
    | "alignment"
    | "list"
    | "indent"
    | "blank"
    | "equation";
  /**
   * The option chosen, never document text: for example heading-1, Arial, 24, center, increase, on. A font size stepper run reports the size it ended on, or increase/decrease for a selection of mixed sizes.
   */
  formatting_value?: string;
  /**
   * The value before the change, same vocabulary as formatting_value. Empty when the selection had mixed values.
   */
  formatting_value_previous?: string;
  /**
   * Whether the action came from a toolbar control or its keyboard shortcut.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | toolbar, shortcut |
   */
  input_method: "toolbar" | "shortcut";
  /**
   * Presentation Studio deck identifier. This is the createPresentation toolCallId, and it joins to presentation_decks.tool_call_id in the warehouse, which is how a funnel here reaches the deck's brief content. Not the deck row id, which does not exist until the first autosave.
   */
  presentation_id?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface CustomStudentToolDeletedProperties {
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface CustomStudentToolOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id: string;
  /**
   * UUID for a teacher or student tool.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  tool_id: string;
  /**
   * Describes the conditions of how the user is viewing the tool.
   *
   * * `edit` – Opened existing tool to edit
   *
   * * `preview` – Opened to preview student-facing tool
   *
   * * `library_review` – Opened library submitted tool for review
   *
   * * `actions_dropdown` – User opened actions dropdown
   *
   * * `edit_access_modal` – User opened tool access modal
   *
   * * `promote_modal` – User opened Move To Library modal
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | edit, preview, library_review, actions_dropdown, edit_access_modal, promote_modal, move_to_library_initiated |
   */
  tool_open_mode:
    | "edit"
    | "preview"
    | "library_review"
    | "actions_dropdown"
    | "edit_access_modal"
    | "promote_modal"
    | "move_to_library_initiated";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface CustomStudentToolPromotedProperties {
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface CustomStudentToolSavedProperties {
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface CustomTeacherToolOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id: string;
  /**
   * UUID for a teacher or student tool.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  tool_id: string;
  /**
   * Describes the conditions of how the user is viewing the tool.
   *
   * * `edit` – Opened existing tool to edit
   *
   * * `preview` – Opened to preview student-facing tool
   *
   * * `library_review` – Opened library submitted tool for review
   *
   * * `actions_dropdown` – User opened actions dropdown
   *
   * * `edit_access_modal` – User opened tool access modal
   *
   * * `promote_modal` – User opened Move To Library modal
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | edit, preview, library_review, actions_dropdown, edit_access_modal, promote_modal, move_to_library_initiated |
   */
  tool_open_mode:
    | "edit"
    | "preview"
    | "library_review"
    | "actions_dropdown"
    | "edit_access_modal"
    | "promote_modal"
    | "move_to_library_initiated";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface CustomTeacherToolPromotedProperties {
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface CustomToolPromoteDismissedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Describes if a custom tool is a teacher or student tool.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | student, teacher |
   */
  custom_tool_type: "student" | "teacher";
}

export interface DocumentClosedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Type"?: string;
  "[Amplitude] Session Replay ID"?: string;
  /**
   * How the Studio panel stopped showing the artifact: close_clicked is its own close button, panel_dismissed is the panel's dismiss or Escape, switched is another artifact replacing it, replaced_by_history is the chat history panel taking its place, thread_left is the teacher leaving the thread (switching threads, a new chat, back/forward, or leaving the page).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | close_clicked, panel_dismissed, switched, replaced_by_history, thread_left |
   */
  close_reason?: "close_clicked" | "panel_dismissed" | "switched" | "replaced_by_history" | "thread_left";
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  editor_mode?: any;
  /**
   * Raina message that triggered classification
   */
  message_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  template_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  template_slug?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | preset, user_saved, none |
   */
  template_source?: "preset" | "user_saved" | "none";
  /**
   * Raina thread the message belongs to
   */
  thread_id?: string;
  /**
   * Milliseconds between the panel opening an artifact and closing it.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  time_open_ms?: number;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
  /**
   * The teacher's stored editor layout choice: paged shows paper sheets, pageless is one continuous page. Not the temporary paged layout used while printing.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | paged, pageless |
   */
  view_mode?: "paged" | "pageless";
}

export interface DocumentEditedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Type"?: string;
  "[Amplitude] Session Replay ID"?: string;
  block_count?: any;
  /**
   * Which chat surface the Studio panel opened on, derived from live chat state. Values: raina, tool, insights, preview. Student is omitted because Amplitude is not loaded on the student layout.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | raina, tool, insights, preview |
   */
  document_entry_point?: "raina" | "tool" | "insights" | "preview";
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  /**
   * Where the edit came from: typing (local), a paste, a drop, undo or redo, or an AI edit (llm).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | local, paste, drop, undo-redo, llm |
   */
  edit_source: "local" | "paste" | "drop" | "undo-redo" | "llm";
  /**
   * Whether the edit changed blocks in place, added them, removed them, or moved them.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | update, move, insert, delete |
   */
  edit_type: "update" | "move" | "insert" | "delete";
  editor_mode?: any;
  grade_level?: any;
  /**
   * Whether the action came from a toolbar control or its keyboard shortcut.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | toolbar, shortcut |
   */
  input_method?: "toolbar" | "shortcut";
  is_blank?: any;
  /**
   * Raina message that triggered classification
   */
  message_id?: string;
  /**
   * The kinds of block the paste carried: paragraph, heading, list, table, image, math.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  paste_block_types?: string[];
  /**
   * What the clipboard held: plain text, rich HTML (Docs, Word, the web), markdown, image files, or a copy out of a ProseMirror editor such as another MagicSchool document. Never the pasted content itself.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | plain_text, html, markdown, image_file, magicschool_copy |
   */
  paste_content_type?: "plain_text" | "html" | "markdown" | "image_file" | "magicschool_copy";
  /**
   * Whether the paste carried any picture.
   */
  paste_has_images?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  template_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  template_slug?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | preset, user_saved, none |
   */
  template_source?: "preset" | "user_saved" | "none";
  text_length?: any;
  /**
   * Raina thread the message belongs to
   */
  thread_id?: string;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
  /**
   * The teacher's stored editor layout choice: paged shows paper sheets, pageless is one continuous page. Not the temporary paged layout used while printing.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | paged, pageless |
   */
  view_mode?: "paged" | "pageless";
}

export interface DocumentExportedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Type"?: string;
  "[Amplitude] Session Replay ID"?: string;
  band?: any;
  custom_block_count?: any;
  /**
   * Which chat surface the Studio panel opened on, derived from live chat state. Values: raina, tool, insights, preview. Student is omitted because Amplitude is not loaded on the student layout.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | raina, tool, insights, preview |
   */
  document_entry_point?: "raina" | "tool" | "insights" | "preview";
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  editor_mode?: any;
  /**
   * Milliseconds from the start of the export to its outcome.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  export_duration_ms?: number;
  /**
   * Why a failed export failed. Empty when the export succeeded.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | google_admin_policy, google_popup_blocked, google_auth, unknown |
   */
  export_error_type?: "google_admin_policy" | "google_popup_blocked" | "google_auth" | "unknown";
  /**
   * Outcome of a document export. For print, succeeded means the print dialog opened. oauth_cancelled means the teacher closed or declined the Google sign-in popup, so nothing was exported.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | succeeded, failed, oauth_cancelled |
   */
  export_status?: "succeeded" | "failed" | "oauth_cancelled";
  export_type: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  format?: string;
  full_thread?: any;
  grade_level?: any;
  image_count?: any;
  key_pressed?: any;
  /**
   * Raina message that triggered classification
   */
  message_id?: string;
  /**
   * Number of pages in the document's paged layout.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  page_count?: number;
  /**
   * Page size the document was laid out on, set from the teacher's country.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | letter, a4 |
   */
  paper_size?: "letter" | "a4";
  show_user_prompt?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  template_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  template_slug?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | preset, user_saved, none |
   */
  template_source?: "preset" | "user_saved" | "none";
  theme?: any;
  /**
   * Raina thread the message belongs to
   */
  thread_id?: string;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
  /**
   * The teacher's stored editor layout choice: paged shows paper sheets, pageless is one continuous page. Not the temporary paged layout used while printing.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | paged, pageless |
   */
  view_mode?: "paged" | "pageless";
}

export interface DocumentGeneratedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Type"?: string;
  "[Amplitude] Session Replay ID"?: string;
  band?: any;
  block_count?: any;
  custom_block_count?: any;
  /**
   * Which chat surface the Studio panel opened on, derived from live chat state. Values: raina, tool, insights, preview. Student is omitted because Amplitude is not loaded on the student layout.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | raina, tool, insights, preview |
   */
  document_entry_point?: "raina" | "tool" | "insights" | "preview";
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  editor_mode?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  format?: string;
  /**
   * Outcome of the generation
   */
  generation_status: string;
  generation_surface?: any;
  generation_type?: any;
  grade_level?: any;
  image_count?: any;
  is_blank?: any;
  /**
   * Raina message that triggered classification
   */
  message_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  template_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  template_slug?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | preset, user_saved, none |
   */
  template_source?: "preset" | "user_saved" | "none";
  text_length?: any;
  theme?: any;
  /**
   * Raina thread the message belongs to
   */
  thread_id?: string;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface DocumentOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Which chat surface the Studio panel opened on, derived from live chat state. Values: raina, tool, insights, preview. Student is omitted because Amplitude is not loaded on the student layout.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | raina, tool, insights, preview |
   */
  document_entry_point: "raina" | "tool" | "insights" | "preview";
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  /**
   * What caused the Studio panel to open. generation_autoswitch is the only value the user did not request.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | edit_clicked, document_link, generation_autoswitch |
   */
  document_open_reason: "edit_clicked" | "document_link" | "generation_autoswitch";
  /**
   * What the Studio panel did. opened means it was closed; switched means it was already open on another document. Reopening the document already shown emits nothing.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | opened, switched |
   */
  document_open_transition: "opened" | "switched";
  message_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  template_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  template_slug?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | preset, user_saved, none |
   */
  template_source?: "preset" | "user_saved" | "none";
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  thread_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  tool_customization_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  tool_slug: string;
  /**
   * The teacher's stored editor layout choice: paged shows paper sheets, pageless is one continuous page. Not the temporary paged layout used while printing.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | paged, pageless |
   */
  view_mode?: "paged" | "pageless";
}

export interface DocumentPreviewExpandedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  /**
   * Raina message that triggered classification
   */
  message_id?: string;
  /**
   * Number of pages in the document's paged layout.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  page_count?: number;
  /**
   * Raina thread the message belongs to
   */
  thread_id?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface DocumentPreviewPageChangedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  /**
   * Raina message that triggered classification
   */
  message_id?: string;
  /**
   * Number of pages in the document's paged layout.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  page_count?: number;
  /**
   * The 1-based page number navigated to
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  page_number: number;
  /**
   * Raina thread the message belongs to
   */
  thread_id?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface DocumentRenamedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  /**
   * Raina message that triggered classification
   */
  message_id?: string;
  /**
   * Raina thread the message belongs to
   */
  thread_id?: string;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface DocumentTranslatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Type"?: string;
  "[Amplitude] Session Replay ID"?: string;
  block_count?: any;
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  editor_mode?: any;
  is_blank?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  language?: string;
  /**
   * Raina message that triggered classification
   */
  message_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  template_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  template_slug?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | preset, user_saved, none |
   */
  template_source?: "preset" | "user_saved" | "none";
  text_length?: any;
  /**
   * Raina thread the message belongs to
   */
  thread_id?: string;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
  /**
   * Whether the translation came from the Translate button on a message or from a request typed in chat.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | translate_button, chat_request |
   */
  translate_method?: "translate_button" | "chat_request";
}

export interface EnterpriseQuotePageOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Surface where the image was generated. It is used in event segmentation and filtering across image-generation-related events, including Image Limit Hit Impression, Image Reported, Image Exported, and Image Gen Upgrade Action.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | in_thread, presentation_studio, image_tool, studio_document |
   */
  image_source: "in_thread" | "presentation_studio" | "image_tool" | "studio_document";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface EnterpriseStudentToolDeletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id: string;
  /**
   * UUID for a teacher or student tool.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  tool_id: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface EnterpriseStudentToolOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id: string;
  /**
   * UUID for a teacher or student tool.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  tool_id: string;
  /**
   * Describes the conditions of how the user is viewing the tool.
   *
   * * `edit` – Opened existing tool to edit
   *
   * * `preview` – Opened to preview student-facing tool
   *
   * * `library_review` – Opened library submitted tool for review
   *
   * * `actions_dropdown` – User opened actions dropdown
   *
   * * `edit_access_modal` – User opened tool access modal
   *
   * * `promote_modal` – User opened Move To Library modal
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | edit, library_review, actions_dropdown, edit_access_modal, promote_modal |
   */
  tool_open_mode: "edit" | "library_review" | "actions_dropdown" | "edit_access_modal" | "promote_modal";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface EnterpriseStudentToolPreviewedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * UUID for a teacher or student tool.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  tool_id: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface EnterpriseStudentToolUpdatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Refines the type of update happened to an enterprise tool.
   *
   * * `tool_enabled` – Enterprise tool is enabled by org admin
   *
   * * `tool_disabled` – Enterprise tool is disabled by org admin
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | tool_enabled, tool_disabled |
   */
  enterprise_tool_update_type: "tool_enabled" | "tool_disabled";
  /**
   * Number of sites this tool is enabled for.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  sites_enabled_count?: number;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id: string;
  /**
   * UUID for a teacher or student tool.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  tool_id: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface EnterpriseTeacherToolDeletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id: string;
  /**
   * UUID for a teacher or student tool.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  tool_id: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface EnterpriseTeacherToolOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id: string;
  /**
   * UUID for a teacher or student tool.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  tool_id: string;
  /**
   * Describes the conditions of how the user is viewing the tool.
   *
   * * `edit` – Opened existing tool to edit
   *
   * * `preview` – Opened to preview student-facing tool
   *
   * * `library_review` – Opened library submitted tool for review
   *
   * * `actions_dropdown` – User opened actions dropdown
   *
   * * `edit_access_modal` – User opened tool access modal
   *
   * * `promote_modal` – User opened Move To Library modal
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | edit, library_review, actions_dropdown, edit_access_modal, promote_modal |
   */
  tool_open_mode: "edit" | "library_review" | "actions_dropdown" | "edit_access_modal" | "promote_modal";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface EnterpriseTeacherToolPreviewedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * UUID for a teacher or student tool.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  tool_id: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface EnterpriseTeacherToolUpdatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Refines the type of update happened to an enterprise tool.
   *
   * * `tool_enabled` – Enterprise tool is enabled by org admin
   *
   * * `tool_disabled` – Enterprise tool is disabled by org admin
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | tool_enabled, tool_disabled |
   */
  enterprise_tool_update_type: "tool_enabled" | "tool_disabled";
  /**
   * Number of sites this tool is enabled for.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  sites_enabled_count?: number;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id: string;
  /**
   * UUID for a teacher or student tool.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  tool_id: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface FilterActionProperties {
  /**
   * The UI component used: `toggle` (binary on/off), `dropdown` (single-select only — use `multi_select` for multi), `date_picker`. Only present when `filter_type = chip`.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | toggle, dropdown, date_picker |
   */
  filter_input_type?: "toggle" | "dropdown" | "date_picker";
  /**
   * The page or surface where the filter was applied. New surfaces should extend this enum.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | student_tools, teacher_tools, homepage_collections_module, homepage_recommended_tools_module |
   */
  filter_surface:
    | "student_tools"
    | "teacher_tools"
    | "homepage_collections_module"
    | "homepage_recommended_tools_module";
  /**
   * The broad input mechanism used — e.g. `chip` for any chip-based interaction, `search` for text input. New mechanisms should add a new value here.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | chip, search, tab |
   */
  filter_type: "chip" | "search" | "tab";
  /**
   * The applied filter value(s). String for single selections, array of strings for multi-select.
   */
  filter_value: string;
}

export interface ImageAddedProperties {
  /**
   * Outcome of adding the image. limited = the teacher's image generation cap was reached (429). blocked_by_org = the org has image generation disabled and the request was refused with a 403; without this value a whole org's policy setting would land in the image failure rate. failed = a genuine error.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | success, limited, failed, blocked_by_org |
   */
  image_add_status?: "success" | "limited" | "failed" | "blocked_by_org";
  /**
   * The added image's file id, for attribution. Present on the generated path only: an upload has no pipeline id.
   */
  image_id?: string;
  /**
   * Whether the teacher uploaded the image or generated it with AI.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | ai_generated, uploaded |
   */
  image_method?: "ai_generated" | "uploaded";
  /**
   * UUID of an organization
   */
  org_id?: string;
  /**
   * Plan tier of the teacher, from useAuth().planId. Needed for the budget and cap questions and for per-tier image enforcement.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  plan?: number;
  /**
   * Presentation Studio deck identifier. The createPresentation toolCallId, which joins to presentation_decks.tool_call_id in the warehouse.
   */
  presentation_id?: string;
  /**
   * Which entry path the presentation came from: the tool form (tool) or a freeform Raina prompt (in_thread). The primary analysis split, and the mirror of the warehouse source column. Follows Image Gen's in_thread naming.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | tool, in_thread |
   */
  presentation_source?: "tool" | "in_thread";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug?: string;
}

export interface ImageExportedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * What way the user exported something from the app
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | download, copy |
   */
  export_method: "download" | "copy";
  /**
   * UUID of the inspiration gallery row the teacher exported from. Absent on exports from other surfaces.
   */
  image_gallery_item_id?: string;
  /**
   * The generated image's file ID. Optional here because a gallery item whose source image was deleted has no file ID; those exports carry gallery_item_id instead.
   */
  image_id?: string;
  /**
   * Surface where the image was generated. It is used in event segmentation and filtering across image-generation-related events, including Image Limit Hit Impression, Image Reported, Image Exported, and Image Gen Upgrade Action.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | in_thread, presentation_studio, inspiration_gallery |
   */
  image_source: "in_thread" | "presentation_studio" | "inspiration_gallery";
  /**
   * Underlying LLM Model
   */
  model_used?: string;
  /**
   * UUID of an organization
   */
  org_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  provider?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface ImageGenUpgradeActionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Surface where the image was generated. It is used in event segmentation and filtering across image-generation-related events, including Image Limit Hit Impression, Image Reported, Image Exported, and Image Gen Upgrade Action.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | in_thread, presentation_studio, image_tool, studio_document |
   */
  image_source: "in_thread" | "presentation_studio" | "image_tool" | "studio_document";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface ImageReportedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The generated image's file ID
   */
  image_id: string;
  /**
   * Surface where the image was generated. It is used in event segmentation and filtering across image-generation-related events, including Image Limit Hit Impression, Image Reported, Image Exported, and Image Gen Upgrade Action.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | in_thread, presentation_studio, image_tool, studio_document |
   */
  image_source: "in_thread" | "presentation_studio" | "image_tool" | "studio_document";
  /**
   * Whether the user completed or dismissed the modal
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | submitted, dismissed |
   */
  modal_action: "submitted" | "dismissed";
  /**
   * Underlying LLM Model
   */
  model_used: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  provider?: string;
  /**
   * Reasons selected in the image report modal.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  report_reason?: ("adult_sexual" | "violent" | "hateful" | "not_appropriate" | "wrong_off_topic" | "other")[];
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface InspirationGalleryOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface InspirationGallerySearchedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  query: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  result_count: number;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
  zero_result: boolean;
}

export interface InspirationPromptAppliedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * UUID of the inspiration gallery row the teacher acted on.
   */
  image_gallery_item_id: string;
  /**
   * UUID of the generated image this gallery row was copied from, when that link exists.
   */
  source_image_id?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface InternalAdminDemoOrgAccessedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * role used to access impersonation
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | teacher_persistent, org_admin_persistent, teacher_temporary, org_admin_temporary, student_temporary, site_admin_temporary |
   */
  access_role:
    | "teacher_persistent"
    | "org_admin_persistent"
    | "teacher_temporary"
    | "org_admin_temporary"
    | "student_temporary"
    | "site_admin_temporary";
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
}

export interface InternalAdminDemoOrgCreatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
}

export interface InternalAdminDemoOrgCreationStartedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
}

export interface InternalAdminDemoOrgDeletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
}

export interface InternalAdminDemoOrgFeatureSettingsUpdatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
}

export interface InternalAdminDemoOrgToolAccessUpdatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
}

export interface InternalAdminOrganizationBulkActionsOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
}

export interface InternalAdminOrganizationFeatureSettingsUpdatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * A feature/tool in an organization that's enabled/disabled
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | google_drive, canvas, glows&grows, score_breakdown, quizzes, schoology, bulk_writing_feedback, google_classroom, student_export_student_threads, knowledge, teacher_export_student_threads, pdf_download, next_steps, lom_purchased, onedrive, image_gen |
   */
  admin_organization_feature:
    | "google_drive"
    | "canvas"
    | "glows&grows"
    | "score_breakdown"
    | "quizzes"
    | "schoology"
    | "bulk_writing_feedback"
    | "google_classroom"
    | "student_export_student_threads"
    | "knowledge"
    | "teacher_export_student_threads"
    | "pdf_download"
    | "next_steps"
    | "lom_purchased"
    | "onedrive"
    | "image_gen";
  /**
   * Whether the feature toggle change was confirmed or cancelled
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | successful, cancelled |
   */
  feature_settings_status: "successful" | "cancelled";
  /**
   * The updated access enabled/disabled for a given tool/feature.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | enabled, disabled |
   */
  new_access_type: "enabled" | "disabled";
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
  /**
   * The status of an organization: active/inactive/etc.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active, paused, deleted |
   */
  organization_status: "active" | "paused" | "deleted";
}

export interface InternalAdminOrganizationIntegrationsOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
}

export interface InternalAdminOrganizationNotesOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
}

export interface InternalAdminOrganizationOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
  /**
   * The status of an organization: active/inactive/etc.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active, paused, deleted |
   */
  organization_status: "active" | "paused" | "deleted";
}

export interface InternalAdminOrganizationReportingOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
}

export interface InternalAdminOrganizationSyncHistoryOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
}

export interface InternalAdminOrganizationToolAccessOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
}

export interface InternalAdminOrganizationToolAccessUpdatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The updated access enabled/disabled for a given tool/feature.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | enabled, disabled |
   */
  new_access_type: "enabled" | "disabled";
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
  /**
   * The status of an organization: active/inactive/etc.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active, paused, deleted |
   */
  organization_status: "active" | "paused" | "deleted";
  /**
   * The category of tool access for an organization. The only value is magic_student.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | magic_student |
   */
  tool_access_category: "magic_student";
  /**
   * Whether the tool access toggle change was confirmed or cancelled
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | successful, cancelled |
   */
  tool_access_status: "successful" | "cancelled";
}

export interface InternalAdminOrganizationUsersOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
}

export interface InternalAdminResetPasswordEmailSentProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
  /**
   * Email of the user affected.
   */
  user_impacted_email: string;
  /**
   * Subscription plan of the user affected. (1: free 2: plus 3: partner)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | 1, 2, 3 |
   */
  user_impacted_plan: "1" | "2" | "3";
  /**
   * Role of the user affected: (teacher, student, admin, internal, superuser).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | student, teacher, org_admin, internal, superuser |
   */
  user_impacted_role: "student" | "teacher" | "org_admin" | "internal" | "superuser";
  /**
   * The status (active/inactive/etc.) of the user impacted.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active, deleted, pending |
   */
  user_impacted_status: "active" | "deleted" | "pending";
}

export interface InternalAdminUserDeletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The text a user enters for deletion notes. Can be empty; an optional field.
   */
  deletion_notes?: string;
  /**
   * The reason selected from the reason dropdown when deleting a user.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | free_account_no_longer_needed, student_created_as_teacher, active_support_interaction, duplicate_account, other |
   */
  deletion_reason:
    | "free_account_no_longer_needed"
    | "student_created_as_teacher"
    | "active_support_interaction"
    | "duplicate_account"
    | "other";
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
  /**
   * Email of the user affected.
   */
  user_impacted_email: string;
  /**
   * Subscription plan of the user affected. (1: free 2: plus 3: partner)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | 1, 2, 3 |
   */
  user_impacted_plan: "1" | "2" | "3";
  /**
   * Role of the user affected: (teacher, student, admin, internal, superuser).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | student, teacher, org_admin, internal, superuser |
   */
  user_impacted_role: "student" | "teacher" | "org_admin" | "internal" | "superuser";
  /**
   * The status (active/inactive/etc.) of the user impacted.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active, deleted, pending |
   */
  user_impacted_status: "active" | "deleted" | "pending";
}

export interface InternalAdminUserEventSyncsOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
  /**
   * Email of the user affected.
   */
  user_impacted_email: string;
  /**
   * Subscription plan of the user affected. (1: free 2: plus 3: partner)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | 1, 2, 3 |
   */
  user_impacted_plan: "1" | "2" | "3";
  /**
   * Role of the user affected: (teacher, student, admin, internal, superuser).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | student, teacher, org_admin, internal, superuser |
   */
  user_impacted_role: "student" | "teacher" | "org_admin" | "internal" | "superuser";
  /**
   * The status (active/inactive/etc.) of the user impacted.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active, deleted, pending |
   */
  user_impacted_status: "active" | "deleted" | "pending";
}

export interface InternalAdminUserFeatureAccessUpdatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The updated access enabled/disabled for a given tool/feature.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | enabled, disabled |
   */
  new_access_type: "enabled" | "disabled";
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
  /**
   * The feature of the site a user has/does not have access to.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | enable_magic_student, enable_quizzes, enable_bulk_writing_feedback |
   */
  user_feature: "enable_magic_student" | "enable_quizzes" | "enable_bulk_writing_feedback";
  /**
   * Email of the user affected.
   */
  user_impacted_email: string;
  /**
   * Subscription plan of the user affected. (1: free 2: plus 3: partner)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | 1, 2, 3 |
   */
  user_impacted_plan: "1" | "2" | "3";
  /**
   * Role of the user affected: (teacher, student, admin, internal, superuser).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | student, teacher, org_admin, internal, superuser |
   */
  user_impacted_role: "student" | "teacher" | "org_admin" | "internal" | "superuser";
  /**
   * The status (active/inactive/etc.) of the user impacted.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active, deleted, pending |
   */
  user_impacted_status: "active" | "deleted" | "pending";
}

export interface InternalAdminUserImpersonatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
  /**
   * Email of the user affected.
   */
  user_impacted_email: string;
  /**
   * Subscription plan of the user affected. (1: free 2: plus 3: partner)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | 1, 2, 3 |
   */
  user_impacted_plan: "1" | "2" | "3";
  /**
   * Role of the user affected: (teacher, student, admin, internal, superuser).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | student, teacher, org_admin, internal, superuser |
   */
  user_impacted_role: "student" | "teacher" | "org_admin" | "internal" | "superuser";
  /**
   * The status (active/inactive/etc.) of the user impacted.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active, deleted, pending |
   */
  user_impacted_status: "active" | "deleted" | "pending";
}

export interface InternalAdminUserMigratedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * String containing user's input for migration reason, blank if none typed.
   */
  migration_reason?: string;
  /**
   * The original email the user was associated to and is attempting to migrate from.
   */
  source_user_email: string;
  /**
   * The target email. The email being migrated to.
   */
  target_user_email: string;
  /**
   * Determines whether a migration was successful or failed.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | successful, failed |
   */
  user_migration_status: "successful" | "failed";
}

export interface InternalAdminUserMigrationSearchedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Determines whether a search was made for a source/origin email or target user's email.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | source, target |
   */
  migration_role: "source" | "target";
  /**
   * Whether a search result was found or not on the Migrate User page after a search was made.
   */
  search_result_found: any;
  /**
   * Email of the user affected.
   */
  user_impacted_email: string;
}

export interface InternalAdminUserRemovedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
  /**
   * Email of the user affected.
   */
  user_impacted_email: string;
  /**
   * Subscription plan of the user affected. (1: free 2: plus 3: partner)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | 1, 2, 3 |
   */
  user_impacted_plan: "1" | "2" | "3";
  /**
   * Role of the user affected: (teacher, student, admin, internal, superuser).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | student, teacher, org_admin, internal, superuser |
   */
  user_impacted_role: "student" | "teacher" | "org_admin" | "internal" | "superuser";
  /**
   * The status (active/inactive/etc.) of the user impacted.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active, deleted, pending |
   */
  user_impacted_status: "active" | "deleted" | "pending";
}

export interface InternalAdminUserRoleUpdatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
  /**
   * The role the user was before updating.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | student, teacher, org_admin, internal, superuser |
   */
  previous_user_impacted_role: "student" | "teacher" | "org_admin" | "internal" | "superuser";
  /**
   * The role a user is updated to.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | student, teacher, org_admin, internal, superuser |
   */
  updated_user_impacted_role: "student" | "teacher" | "org_admin" | "internal" | "superuser";
  /**
   * Email of the user affected.
   */
  user_impacted_email: string;
  /**
   * Subscription plan of the user affected. (1: free 2: plus 3: partner)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | 1, 2, 3 |
   */
  user_impacted_plan: "1" | "2" | "3";
  /**
   * The status (active/inactive/etc.) of the user impacted.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active, deleted, pending |
   */
  user_impacted_status: "active" | "deleted" | "pending";
}

export interface ManualSsoSyncTriggeredProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * UUID of an organization
   */
  org_id: string;
}

export interface ModerationSettingsLeftUnsavedProperties {
  /**
   * The moderation-settings section path the admin left from: one of the categories, keywords, alerting, or denied-topics routes.
   */
  moderation_settings_path?: string;
  /**
   * The moderation-settings section path the admin left from (categories, keywords, alerting, denied-topics).
   */
  path?: string;
}

export interface ModuleRemovedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The name of the module.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | flex_card |
   */
  module_name: "flex_card";
  /**
   * The surface where the module is located.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | homepage |
   */
  module_surface: "homepage";
}

export interface NavigationActionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Type"?: string;
  /**
   * The destination page navigated to as a result of the action.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | customize, teacher_tools, student_tools, workflows, quizzes, class_writing_feedback, collections, profile, raina, subscription, image_generator, presentation_generator, student_rooms, authentic_writing |
   */
  destination_page:
    | "customize"
    | "teacher_tools"
    | "student_tools"
    | "workflows"
    | "quizzes"
    | "class_writing_feedback"
    | "collections"
    | "profile"
    | "raina"
    | "subscription"
    | "image_generator"
    | "presentation_generator"
    | "student_rooms"
    | "authentic_writing";
  /**
   * The specific navigation interaction performed. Add a new value for each distinct CTA or action.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | clicked_create_custom_tool, clicked_teacher, clicked_student, clicked_workflows, clicked_go_to_assignments, clicked_create_assignment, clicked_create_quiz, clicked_see_collections, clicked_discover_all_tools, clicked_see_teacher_tools, clicked_profile, clicked_recent_activity_item, clicked_recent_activity_source, clicked_upgrade, clicked_go_to_quizzes, clicked_featured_card, clicked_create_writing_assignment, clicked_go_to_writing_assignments |
   */
  navigation_action:
    | "clicked_create_custom_tool"
    | "clicked_teacher"
    | "clicked_student"
    | "clicked_workflows"
    | "clicked_go_to_assignments"
    | "clicked_create_assignment"
    | "clicked_create_quiz"
    | "clicked_see_collections"
    | "clicked_discover_all_tools"
    | "clicked_see_teacher_tools"
    | "clicked_profile"
    | "clicked_recent_activity_item"
    | "clicked_recent_activity_source"
    | "clicked_upgrade"
    | "clicked_go_to_quizzes"
    | "clicked_featured_card"
    | "clicked_create_writing_assignment"
    | "clicked_go_to_writing_assignments";
  /**
   * The surface or page from which the navigation action was initiated.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | collections, teacher_tools, student_tools, workflows, homepage_recommendations_module_student, homepage_recommended_tools_module, class_writing_feedback, homepage_collections_module, homepage_recent_activity_module, usage_limit_banner, homepage_featured_cards_module |
   */
  navigation_surface:
    | "collections"
    | "teacher_tools"
    | "student_tools"
    | "workflows"
    | "homepage_recommendations_module_student"
    | "homepage_recommended_tools_module"
    | "class_writing_feedback"
    | "homepage_collections_module"
    | "homepage_recent_activity_module"
    | "usage_limit_banner"
    | "homepage_featured_cards_module";
}

export interface OnboardingStepInteractionProperties {
  has_prior_completed_profile: boolean;
  /**
   * The onboarding step the user was on when they interacted with the next/back control.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | welcome, profession, location, institution, grades, subjects, name, best_practices |
   */
  onboarding_step:
    | "welcome"
    | "profession"
    | "location"
    | "institution"
    | "grades"
    | "subjects"
    | "name"
    | "best_practices";
  /**
   * Whether the interaction advanced the user to the next step or returned them to the previous step.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | back, next |
   */
  onboarding_step_direction: "back" | "next";
  /**
   * Currently, ProfileBuilder is the only value.  This enum may be expanded in the future if we add alternative onboarding methods and want to A/B them.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | profile_builder |
   */
  onboarding_surface: "profile_builder";
}

export interface OrgCustomizationSavedProperties {
  /**
   * Boolean to track if the welcome message has any url/link in the message.
   */
  has_links: boolean;
  /**
   * The total length of characters for the message.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  message_length: number;
}

export interface PresentationClosedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * How the Studio panel stopped showing the artifact: close_clicked is its own close button, panel_dismissed is the panel's dismiss or Escape, switched is another artifact replacing it.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | close_clicked, panel_dismissed, switched, replaced_by_history, thread_left, system |
   */
  close_reason: "close_clicked" | "panel_dismissed" | "switched" | "replaced_by_history" | "thread_left" | "system";
  /**
   * Presentation Studio deck identifier. This is the createPresentation toolCallId, and it joins to presentation_decks.tool_call_id in the warehouse, which is how a funnel here reaches the deck's brief content. Not the deck row id, which does not exist until the first autosave.
   */
  presentation_id: string;
  /**
   * Which entry path the presentation came from: the tool form (tool) or a freeform Raina prompt (in_thread). The primary analysis split, and the mirror of the warehouse source column. Follows Image Gen's in_thread naming.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | tool, in_thread |
   */
  presentation_source?: "tool" | "in_thread";
  /**
   * Milliseconds between the panel opening an artifact and closing it.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  time_open_ms?: number;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface PresentationExportedProperties {
  /**
   * UUID of an organization
   */
  org_id?: string;
  /**
   * Whether the export produced a file or a Slides deck.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | success, failed |
   */
  presentation_export_status?: "success" | "failed";
  /**
   * Where the teacher triggered the export: the studio canvas header, or the in-thread deck card. Both call the same hook, so this is threaded in as a prop.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | studio, thread_card |
   */
  presentation_export_surface?: "studio" | "thread_card";
  /**
   * Export destination. There is no PDF path yet; LUNCH-422 tracks it, and this enum gains a member when it lands.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | pptx, google_slides |
   */
  presentation_export_target?: "pptx" | "google_slides";
  /**
   * Presentation Studio deck identifier. The createPresentation toolCallId, which joins to presentation_decks.tool_call_id in the warehouse.
   */
  presentation_id?: string;
  /**
   * Number of slides in the deck at the time of export.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  presentation_slide_count?: number;
  /**
   * Which entry path the presentation came from: the tool form (tool) or a freeform Raina prompt (in_thread). The primary analysis split, and the mirror of the warehouse source column. Follows Image Gen's in_thread naming.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | tool, in_thread |
   */
  presentation_source?: "tool" | "in_thread";
}

export interface PresentationGeneratedProperties {
  /**
   * Wall-clock duration of the refine request in milliseconds, timed client-side.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  generation_duration_ms?: number;
  /**
   * UUID of an organization
   */
  org_id?: string;
  /**
   * Plan tier of the teacher, from useAuth().planId. Needed for the budget and cap questions and for per-tier image enforcement.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  plan?: number;
  /**
   * Number of settled slides that carry no content beyond a title. A non-zero value on an otherwise successful deck is a partial failure.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  presentation_blank_slide_count?: number;
  /**
   * Which failure produced a non-success presentation_generation_status. none on success, partial and stopped.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | plan_unusable, all_slides_failed, none |
   */
  presentation_error_type?: "plan_unusable" | "all_slides_failed" | "none";
  /**
   * Terminal outcome of a deck build. success = every slide settled with content. partial = the deck is usable but some slides settled blank. slides_failed = no slide survived. plan_failed = the outline was unusable after a retry. stopped = the teacher stopped it. Replaces the shared generation_status, which four unrelated events also use.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | success, partial, slides_failed, plan_failed, stopped |
   */
  presentation_generation_status: "success" | "partial" | "slides_failed" | "plan_failed" | "stopped";
  /**
   * Presentation Studio deck identifier. The createPresentation toolCallId, which joins to presentation_decks.tool_call_id in the warehouse.
   */
  presentation_id?: string;
  /**
   * Number of slides refused with a 429 during generation and degraded to blanks. This is the signal for how often a teacher hits their cap mid-deck.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  presentation_rate_limited_slide_count?: number;
  /**
   * Number of slides that finished generating, provisional slides excluded.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  presentation_slide_count_generated?: number;
  /**
   * Number of slides the teacher asked for in the brief. Compare against slide_count_settled to see how often generation delivered the requested length.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  presentation_slide_count_requested?: number;
  /**
   * Which entry path the presentation came from: the tool form (tool) or a freeform Raina prompt (in_thread). The primary analysis split, and the mirror of the warehouse source column. Follows Image Gen's in_thread naming.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | tool, in_thread |
   */
  presentation_source?: "tool" | "in_thread";
}

export interface PresentationOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Presentation Studio deck identifier. This is the createPresentation toolCallId, and it joins to presentation_decks.tool_call_id in the warehouse, which is how a funnel here reaches the deck's brief content. Not the deck row id, which does not exist until the first autosave.
   */
  presentation_id: string;
  /**
   * What opened the deck: the teacher's Edit button or card, the panel switching to a deck as it starts generating, or an AI edit in chat reopening a deck that was closed or behind another artifact.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | edit_clicked, generation_autoswitch, ai_edit_reopen |
   */
  presentation_open_reason: "edit_clicked" | "generation_autoswitch" | "ai_edit_reopen";
  /**
   * Which entry path the presentation came from: the tool form (tool) or a freeform Raina prompt (in_thread). The primary analysis split, and the mirror of the warehouse source column. Follows Image Gen's in_thread naming.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | tool, in_thread |
   */
  presentation_source?: "tool" | "in_thread";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface PresentationRefinedProperties {
  /**
   * Set only when the change came from a history step rather than a fresh edit: undo when the teacher stepped back, redo when they stepped forward. Absent on every ordinary edit, so absent and "not a history step" mean the same thing. Deliberately generic and un-namespaced so any surface with an undo stack can reuse it. Orthogonal to the event's own action property, which still names what changed, so an undo of a theme change reads as presentation_refine_type change_theme with history_action undo.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | undo, redo |
   */
  history_action?: "undo" | "redo";
  /**
   * UUID of an organization
   */
  org_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  plan?: number;
  /**
   * Presentation Studio deck identifier. The createPresentation toolCallId, which joins to presentation_decks.tool_call_id in the warehouse.
   */
  presentation_id?: string;
  /**
   * Whether the refinement targeted one slide or the whole deck.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | slide, presentation |
   */
  presentation_refine_scope?: "slide" | "presentation";
  /**
   * Outcome of the refine request. cancelled covers a teacher navigating away or starting another refine mid-flight.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | success, failed, cancelled |
   */
  presentation_refine_status?: "success" | "failed" | "cancelled";
  /**
   * What the teacher changed. Manual editor actions: edit_text (committed text in a block), restyle_slide (block style or alignment), change_layout (slide archetype), change_theme (theme picker), add_slide, duplicate_slide, delete_slide, move_slide, rename_deck, delete_block. AI actions: regenerate_slide (the blank-slide Regenerate control) and edit_with_ai (any chat-driven edit, slide or deck scoped). Excludes the automatic blank-slide repair, which is not a user action and never emits this event. Image add and remove are not here: they emit Image Added.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | edit_text, regenerate_slide, restyle_slide, change_theme, change_layout, edit_with_ai, add_slide, duplicate_slide, delete_slide, move_slide, rename_deck, delete_block |
   */
  presentation_refine_type?:
    | "edit_text"
    | "regenerate_slide"
    | "restyle_slide"
    | "change_theme"
    | "change_layout"
    | "edit_with_ai"
    | "add_slide"
    | "duplicate_slide"
    | "delete_slide"
    | "move_slide"
    | "rename_deck"
    | "delete_block";
  /**
   * Which entry path the presentation came from: the tool form (tool) or a freeform Raina prompt (in_thread). The primary analysis split, and the mirror of the warehouse source column. Follows Image Gen's in_thread naming.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | tool, in_thread |
   */
  presentation_source?: "tool" | "in_thread";
  /**
   * Wall-clock duration of the refine request in milliseconds, timed client-side from the teacher's action to the settled slide or deck. Kept separate from generation_duration_ms so one property never means two different spans.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  refine_duration_ms?: number;
  tool_slug?: string;
}

export interface PresentationRequestedProperties {
  /**
   * Locale the deck was requested in.
   */
  language?: string;
  /**
   * UUID of an organization
   */
  org_id?: string;
  /**
   * Grade band the deck was requested for. Deliberately separate from the existing grade_band property, which is a user attribute describing the grades a teacher teaches and uses a different vocabulary (elementary/middle/high-school). This one is a per-deck request parameter.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | K-2, 3-5, 6-8, 9-12 |
   */
  presentation_grade_band?: "K-2" | "3-5" | "6-8" | "9-12";
  /**
   * Where presentation_grade_band came from. 'stated' is the tool form's grade control, which replaces whatever the model sent. 'inferred' is the model's createPresentation argument, used when the form stated nothing. Without this, a teacher's choice and a model's guess are indistinguishable.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | stated, inferred |
   */
  presentation_grade_band_source?: "stated" | "inferred";
  /**
   * Whether the teacher supplied class context in the brief.
   */
  presentation_has_class_context?: boolean;
  /**
   * Whether the teacher supplied standards in the brief.
   */
  presentation_has_standards?: boolean;
  /**
   * Presentation Studio deck identifier. The createPresentation toolCallId, which joins to presentation_decks.tool_call_id in the warehouse.
   */
  presentation_id?: string;
  /**
   * Number of slides the teacher asked for in the brief. Compare against slide_count_settled to see how often generation delivered the requested length.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  presentation_slide_count_requested?: number;
  /**
   * Which entry path the presentation came from: the tool form (tool) or a freeform Raina prompt (in_thread). The primary analysis split, and the mirror of the warehouse source column. Follows Image Gen's in_thread naming.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | tool, in_thread |
   */
  presentation_source?: "tool" | "in_thread";
  /**
   * Presentation Studio theme preset the deck was built with. Empty when the palette was generated from the topic rather than a preset, which is the normal case.
   */
  presentation_theme_id?: string;
  /**
   * Character length of the teacher's brief request text. The text itself is deliberately not sent: brief content lives in presentation_decks.brief in the warehouse.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  prompt_length?: number;
  /**
   * Raina thread the deck was requested in
   */
  thread_id?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug?: string;
}

export interface PrintableExportedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  /**
   * How the printable left Studio: print, google_doc, word_docx, or copy_to_clipboard.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | print, google_doc, word_docx, copy_to_clipboard |
   */
  export_type: "print" | "google_doc" | "word_docx" | "copy_to_clipboard";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface PrintableRevisedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface ProfileUpdateClosedProperties {
  /**
   * How many times the user has already dismissed the hard-phase profile refresh modal this season, counting this blocked attempt. Only set for profile_refresh_modal.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   * | Min Value | 0 |
   */
  hard_dismissals_used?: number;
  /**
   * Which surface the impression occurred on: profile_refresh_modal, profile_builder, or profile_page.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | profile_refresh_modal, profile_builder, profile_page |
   */
  profile_update_surface: "profile_refresh_modal" | "profile_builder" | "profile_page";
}

export interface ProfileUpdateImpressionProperties {
  has_prior_completed_profile: boolean;
  /**
   * Records whether the profile update modal is dismissable to the user.
   */
  is_dismissable?: boolean;
  /**
   * Which surface the impression occurred on: profile_refresh_modal, profile_builder, or profile_page.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | profile_refresh_modal, profile_builder, profile_page |
   */
  profile_update_surface: "profile_refresh_modal" | "profile_builder" | "profile_page";
}

export interface ProfileUpdatedProperties {
  /**
   * The teacher's city on their profile.
   */
  city?: string;
  /**
   * The teacher's country code on the profile after this save.
   */
  country_code?: string;
  /**
   * Which profile fields the user had edited before closing without confirming (e.g. profession, school, grades, subjects, location, name).
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  fields_changed: string[];
  /**
   * The user's.....full name!
   */
  full_name?: string;
  /**
   * The full set of grade levels on the teacher's profile after this save.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  grades?: string[];
  has_prior_completed_profile: boolean;
  /**
   * List of specified institution names
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  institutions?: string[];
  /**
   * The user's selected profession / role (i.e. Teacher, District Administrator, Educator, etc.)
   */
  profession: string;
  /**
   * Which surface the impression occurred on: profile_refresh_modal, profile_builder, or profile_page.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | profile_refresh_modal, profile_builder, profile_page |
   */
  profile_update_surface: "profile_refresh_modal" | "profile_builder" | "profile_page";
  /**
   * The teacher's state or province on the profile after this save.
   */
  state_province?: string;
  /**
   * Teacher's student friendly name.
   */
  student_friendly_name?: string;
  /**
   * The full set of subjects on the teacher's profile after this save.
   *
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  subjects?: string[];
}

export interface PromptStarterImpressionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Identifies which feature these prompt starters are for, used to distinguish events as more features adopt this pattern
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | image_gen, presentation_gen, seasonal_themes |
   */
  prompt_starter_feature: "image_gen" | "presentation_gen" | "seasonal_themes";
  /**
   * The surface where the prompt starter was rendered
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | homepage, raina |
   */
  prompt_starter_surface: "homepage" | "raina";
}

export interface PromptStarterMenuItemAppliedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Identifies which feature these prompt starters are for, used to distinguish events as more features adopt this pattern
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | image_gen, presentation_gen, seasonal_themes |
   */
  prompt_starter_feature: "image_gen" | "presentation_gen" | "seasonal_themes";
  /**
   * Identifies the specific prompt the user selected from the menu
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | collaboration, water_cycle, ancient_egypt, plant_parts, growth_mindset, public_speaking, scientific_method, fall_would_you_rather, halloween_around_the_world, squirrel_counting, fall_five_senses |
   */
  prompt_starter_menu_item:
    | "collaboration"
    | "water_cycle"
    | "ancient_egypt"
    | "plant_parts"
    | "growth_mindset"
    | "public_speaking"
    | "scientific_method"
    | "fall_would_you_rather"
    | "halloween_around_the_world"
    | "squirrel_counting"
    | "fall_five_senses";
  /**
   * The surface where the prompt starter was rendered
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | homepage, raina |
   */
  prompt_starter_surface: "homepage" | "raina";
}

export interface PromptStarterMenuOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Identifies which feature these prompt starters are for, used to distinguish events as more features adopt this pattern
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | image_gen, presentation_gen, seasonal_themes |
   */
  prompt_starter_feature: "image_gen" | "presentation_gen" | "seasonal_themes";
  /**
   * The surface where the prompt starter was rendered
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | homepage, raina |
   */
  prompt_starter_surface: "homepage" | "raina";
}

export interface RecommendationsClickedProperties {
  /**
   * Unique ID denoting a singular instance of an impression.  Can be propogated to click events to link what the user was seeing to what they clicked on.
   */
  impression_id: string;
  /**
   * Version of the model the recommendation engine is using to generate the associated tools.
   */
  model_version: string;
  /**
   * Denotes the slug of the primary category for a given tool.
   */
  primary_category_slug?: string;
  /**
   * The reason the engine has recommended specific tool to the user based on their segment.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | fallback, subject-only-popular, subject-and-grade-popular, global-popular, student-popular, trending, seasonal |
   */
  reason_type:
    | "fallback"
    | "subject-only-popular"
    | "subject-and-grade-popular"
    | "global-popular"
    | "student-popular"
    | "trending"
    | "seasonal";
  /**
   * The page that the recommendations appear on.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | homepage, all-tools, teacher-tools, student-tools |
   */
  recommendation_surface: "homepage" | "all-tools" | "teacher-tools" | "student-tools";
  /**
   * Used to distinguish which pool the tool was sampled from.  i.e. the Exploration pool vs Exploitation pool
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | exploration, exploitation, fallback |
   */
  sampling_strategy: "exploration" | "exploitation" | "fallback";
  /**
   * Used to denote which tag, if any, is present on a tool card.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | hot, new |
   */
  tool_card_tag?: "hot" | "new";
  /**
   * The position that the tool appears within the recommendations. (left-to-right, top-to-bottom)
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  tool_position: number;
  /**
   * The ordered rank of the tool based on recommendation rankings model (within a given segment).
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  tool_rank?: number;
  /**
   * The weighted score of the tool based on recommendation rankings model (within a given segment).
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  tool_score?: number;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
  /**
   * Distinguishes between Teacher tools and Student tools
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | teacher, student |
   */
  tool_type: "teacher" | "student";
}

export interface RecommendationsImpressionProperties {
  /**
   * The range of grades taught by a given user.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | elementary, middle, all, high-school, higher-education, multi-grade |
   */
  grade_band: "elementary" | "middle" | "all" | "high-school" | "higher-education" | "multi-grade";
  /**
   * Unique ID denoting a singular instance of an impression.  Can be propogated to click events to link what the user was seeing to what they clicked on.
   */
  impression_id: string;
  /**
   * Version of the model the recommendation engine is using to generate the associated tools.
   */
  model_version: string;
  /**
   * Provides context on the state of the recommendations module for the given impression event.  For example, it can denote the tab in the module that the user is viewing (i.e. "Student", "Teacher", "Workflows")
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | teacher, student, workflows |
   */
  recommendation_context: "teacher" | "student" | "workflows";
  /**
   * Array of recommendation items visible in the recommendations module.
   *
   * Schema:
   *
   * `tool_slug: String`
   *
   * `primary_category_slug: String`
   *
   * `tool_type: "teacher" | "student"`
   *
   * `tool_score: Number`
   *
   * `tool_rank: Number`
   *
   * `tool_position: Number`
   *
   * `sampling_strategy: "exploration" | "exploitation" | "fallback"`
   *
   * `reason_type: "subject-only-popular" | "subject-and-grade_popular" | "global-popular" | "fallback" | "seasonal" | "trending" | "student-popular"`
   *
   * `tool_card_tag: Enum`
   */
  recommendation_items: any[];
  /**
   * The page that the recommendations appear on.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | homepage, all-tools, teacher-tools, student-tools |
   */
  recommendation_surface: "homepage" | "all-tools" | "teacher-tools" | "student-tools";
  /**
   * The number of populated slots shown to the user.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  slot_count: number;
  /**
   * Name of the primary subject associated with a user.
   */
  subject_name: string;
  /**
   * Distinguishes between new users learning the platform vs graduated users.
   *
   * If a users' state can't be computed for some reason, we will send `unknown`
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | graduated, unknown, new-emerging |
   */
  user_state: "graduated" | "unknown" | "new-emerging";
}

export interface ResourceFileUploadCompletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | network_error, file_too_large, unsupported_format |
   */
  failure_reason?: "network_error" | "file_too_large" | "unsupported_format";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  file_size_bytes: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | pdf, docx, xlsx, png, jpg |
   */
  file_type?: "pdf" | "docx" | "xlsx" | "png" | "jpg";
  /**
   * **Library resource ID (distinct from document_id)**
   */
  resource_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | succeeded, failed, rejected_policy, rejected_size, rejected_virus_scan |
   */
  upload_status: "succeeded" | "failed" | "rejected_policy" | "rejected_size" | "rejected_virus_scan";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | library_direct, raina_thread, tool_form |
   */
  upload_surface: "library_direct" | "raina_thread" | "tool_form";
}

export interface ResourceFileUploadInitiatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  file_size_bytes: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | pdf, docx, xlsx, png, jpg |
   */
  file_type?: "pdf" | "docx" | "xlsx" | "png" | "jpg";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | file_picker, drag_drop, paste |
   */
  upload_method: "file_picker" | "drag_drop" | "paste";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | library_direct, raina_thread, tool_form |
   */
  upload_surface: "library_direct" | "raina_thread" | "tool_form";
}

export interface ResourceLibraryFilteredProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  active_filters_count: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | resource_type, folder, sharing_status, last_updated |
   */
  filter_type: "resource_type" | "folder" | "sharing_status" | "last_updated";
  /**
   * The selected filter value(s)
   *
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  filter_value: string[];
}

export interface ResourceLibrarySearchedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  active_filters: string[];
  query: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  result_count: number;
  zero_result: boolean;
}

export interface ResourceOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Folder placed in, if any
   */
  folder_id?: string;
  /**
   * **Library resource ID (distinct from document_id)**
   */
  resource_id: string;
  /**
   * Type of resource saved
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | response, artifact, upload |
   */
  resource_type: "response" | "artifact" | "upload";
}

export interface ResourcePreviewOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | pdf, docx, xlsx, png, jpg |
   */
  file_type?: "pdf" | "docx" | "xlsx" | "png" | "jpg";
  resource_preview_status: string;
  /**
   * Type of resource saved
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | response, artifact, upload |
   */
  resource_type: "response" | "artifact" | "upload";
}

export interface ResourceReferencedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  assistant_thread_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | raina_thread, tool_form |
   */
  reference_surface: "raina_thread" | "tool_form";
  /**
   * **Library resource ID (distinct from document_id)**
   */
  resource_id: string;
  /**
   * Type of resource saved
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | response, artifact, upload |
   */
  resource_type: "response" | "artifact" | "upload";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug?: string;
}

export interface ResourceRemovedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Folder placed in, if any
   */
  folder_id?: string;
  /**
   * **Library resource ID (distinct from document_id)**
   */
  resource_id: string;
  /**
   * Type of resource saved
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | response, artifact, upload |
   */
  resource_type: "response" | "artifact" | "upload";
  /**
   * Where the save triggered from
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | studio, chat, tool_form, library_direct |
   */
  save_surface: "studio" | "chat" | "tool_form" | "library_direct";
}

export interface ResourceSavedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Folder placed in, if any
   */
  folder_id?: string;
  /**
   * **Library resource ID (distinct from document_id)**
   */
  resource_id: string;
  /**
   * Type of resource saved
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | response, artifact, upload |
   */
  resource_type: "response" | "artifact" | "upload";
  /**
   * Where the save triggered from
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | studio, chat, tool_form, library_direct |
   */
  save_surface: "studio" | "chat" | "tool_form" | "library_direct";
}

export interface SsoIntegrationGuideOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * UUID of an organization
   */
  org_id: string;
  /**
   * Where in the product that the user clicked the SSO integration guide link.
   *
   * * `onboarding_panel` – Visible from `/o/users/onboarding`
   *
   * * `cta_banner` – Banner above `/o/users`
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | onboarding_panel, cta_banner |
   */
  sso_guide_source: "onboarding_panel" | "cta_banner";
}

export interface StartQuizGeneratedProperties {
  /**
   * Tracks whether the grade level validation for a quiz passed/failed
   */
  grade_level_validation_failed: boolean;
  multiple_choice_question_count_validation_failed: boolean;
  /**
   * Number of multiple choice questions for a quiz
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  quiz_multiple_choice_question_count: number;
  /**
   * Number of short answer questions for a quiz
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  quiz_short_answer_question_count: number;
  /**
   * Total number of questions for a quiz
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  quiz_total_question_count: number;
  /**
   * Tracks whether the short answer question validation for a quiz passed/failed
   */
  short_answer_question_count_validation_failed: boolean;
  /**
   * Tracks whether the standard validation for a quiz passed/failed
   */
  standard_validation_failed: boolean;
  /**
   * Tracks whether the topic validation for a quiz passed/failed
   */
  topic_validation_failed: boolean;
}

export interface SubscriptionSubscribeButtonClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * UUID of a user.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  user_id?: string;
}

export interface TableEditedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  /**
   * What the table edit did.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | row_added, row_removed, column_added, column_removed, row_moved, column_moved, resized |
   */
  table_action:
    | "row_added"
    | "row_removed"
    | "column_added"
    | "column_removed"
    | "row_moved"
    | "column_moved"
    | "resized";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface TableFilteredProperties {
  /**
   * The column accessor key being filtered
   */
  filter_column: string;
  /**
   * The selected filter value(s)
   *
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  filter_value: string[];
  /**
   * Identifier for the table instance
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | chat_history |
   */
  table_name: "chat_history";
}

export interface TableFiltersClearedProperties {
  /**
   * Identifier for the table instance
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | chat_history |
   */
  table_name: "chat_history";
}

export interface TablePaginatedProperties {
  /**
   * The 1-based page number navigated to
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  page_number: number;
  /**
   * Number of rows per page
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  page_size: number;
  /**
   * Identifier for the table instance
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | chat_history |
   */
  table_name: "chat_history";
}

export interface TableRowExpansionChangedProperties {
  /**
   * Whether the row was expanded or collapsed
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | expanded, collapsed |
   */
  row_expansion_action: "expanded" | "collapsed";
  /**
   * Unique identifier of the toggled row
   */
  row_id: string;
  /**
   * Identifier for the table instance
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | chat_history |
   */
  table_name: "chat_history";
}

export interface TableRowSelectionChangedProperties {
  /**
   * Total number of rows selected after the change
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  selected_count: number;
  /**
   * Whether the net result was a selection or a deselection
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | selected, deselected |
   */
  selection_action: "selected" | "deselected";
  /**
   * Whether the header "select all" checkbox or a single row checkbox was used
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | header, individual |
   */
  selection_type: "header" | "individual";
  /**
   * Identifier for the table instance
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | chat_history |
   */
  table_name: "chat_history";
}

export interface TableSearchedProperties {
  /**
   * The search string entered by the user
   */
  search_term: string;
  /**
   * Identifier for the table instance
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | chat_history |
   */
  table_name: "chat_history";
}

export interface TableSortedProperties {
  /**
   * The column accessor key that was sorted
   */
  sort_column: string;
  /**
   * The resulting sort direction
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | asc, desc |
   */
  sort_direction: "asc" | "desc";
  /**
   * Identifier for the table instance
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | chat_history |
   */
  table_name: "chat_history";
}

export interface ThreadDeletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Number of deleted threads to differentiate between individual or bulk thread deletion.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  deleted_count: number;
  /**
   * Whether the deletion is individual or bulk.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | individual, bulk |
   */
  deletion_type: "individual" | "bulk";
  /**
   * Raina thread the message belongs to
   */
  thread_id?: string;
  /**
   * The context where the user action was taken.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | recent_history_panel, homepage_recent_activity_module, chat_history |
   */
  thread_surface: "recent_history_panel" | "homepage_recent_activity_module" | "chat_history";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug?: string;
}

export interface ThreadFavoriteRemovedProperties {
  /**
   * Raina thread the message belongs to
   */
  thread_id: string;
  /**
   * The context where the user action was taken.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | recent_history_panel, homepage_recent_activity_module, chat_history |
   */
  thread_surface: "recent_history_panel" | "homepage_recent_activity_module" | "chat_history";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface ThreadFavoritedProperties {
  /**
   * Raina thread the message belongs to
   */
  thread_id: string;
  /**
   * The context where the user action was taken.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | recent_history_panel, homepage_recent_activity_module, chat_history |
   */
  thread_surface: "recent_history_panel" | "homepage_recent_activity_module" | "chat_history";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface ThreadOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Type"?: string;
  /**
   * Raina thread the message belongs to
   */
  thread_id: string;
  /**
   * The context where the user action was taken.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | recent_history_panel, homepage_recent_activity_module, chat_history |
   */
  thread_surface: "recent_history_panel" | "homepage_recent_activity_module" | "chat_history";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface ThreadPreviewedProperties {
  /**
   * Raina thread the message belongs to
   */
  thread_id: string;
  /**
   * The context where the user action was taken.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | recent_history_panel, homepage_recent_activity_module, chat_history |
   */
  thread_surface: "recent_history_panel" | "homepage_recent_activity_module" | "chat_history";
}

export interface ThreadSharingEditedProperties {
  /**
   * The new access level applied
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | private, public, org |
   */
  sharing_type: "private" | "public" | "org";
  /**
   * Raina thread the message belongs to
   */
  thread_id: string;
  /**
   * The context where the user action was taken.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | recent_history_panel, homepage_recent_activity_module, chat_history |
   */
  thread_surface: "recent_history_panel" | "homepage_recent_activity_module" | "chat_history";
}

export interface ThreadTitleEditedProperties {
  /**
   * Raina thread the message belongs to
   */
  thread_id: string;
  /**
   * The context where the user action was taken.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | recent_history_panel, homepage_recent_activity_module, chat_history |
   */
  thread_surface: "recent_history_panel" | "homepage_recent_activity_module" | "chat_history";
}

export interface ToolCallOutputGeneratedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  /**
   * Outcome of the generation
   */
  generation_status: string;
  /**
   * **Tokens sent to the agent**
   */
  input_tokens: string;
  /**
   * Raina message that triggered classification
   */
  message_id: string;
  /**
   * Underlying LLM Model
   */
  model_used: string;
  /**
   * Tokens returned by the agent
   */
  output_tokens: string;
  output_type: string;
  /**
   * Raina thread the message belongs to
   */
  thread_id: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface ToolCardClickedProperties {
  /**
   * The type of filter active when the card was clicked. Omitted when no filter is active.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | category, favorites, enterprise, custom |
   */
  active_filter_type?: "category" | "favorites" | "enterprise" | "custom";
  /**
   * The filter value active when the card was clicked (e.g. a category slug). Omitted when no filter is active.
   */
  active_filter_value?: string;
  /**
   * The page or module where the card was clicked.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | teacher_tools, student_tools, collections, homepage_collections_module, homepage_recommended_tools_module |
   */
  click_surface:
    | "teacher_tools"
    | "student_tools"
    | "collections"
    | "homepage_collections_module"
    | "homepage_recommended_tools_module";
  /**
   * The ID of the collection the card appeared in. Only present on collection surfaces.
   */
  collection_id?: string;
  /**
   * The display name of the collection. Only present on collection surfaces.
   */
  collection_name?: string;
  /**
   * The type of the collection (e.g. curated, custom). Only present on collection surfaces.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | favorites, custom, named |
   */
  collection_type?: "favorites" | "custom" | "named";
  /**
   * Whether the tool is a user-created customization (has a tool_customization_id).
   */
  is_custom_tool: boolean;
  /**
   * Whether the tool is an enterprise-only tool.
   */
  is_enterprise: boolean;
  /**
   * Whether the tool was marked as a favorite by the user at the time of click.
   */
  is_favorited: boolean;
  /**
   * Whether a search was active when the card was clicked.
   */
  search_made: boolean;
  /**
   * The search query string when search_made is true.
   */
  search_query?: string;
  /**
   * The badge displayed on the tool card at time of click. Omitted when no badge is shown.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | hot, new |
   */
  tool_badge?: "hot" | "new";
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id?: string;
  /**
   * UUID for a teacher or student tool.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  tool_id: string;
  /**
   * Total number of tools in the list at time of click. Provides context for tool_position, and equals the search result count when search is active.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  tool_list_size?: number;
  /**
   * The position that the tool appears within the recommendations. (left-to-right, top-to-bottom)
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  tool_position: number;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
  /**
   * Distinguishes between Teacher tools and Student tools
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | teacher, student |
   */
  tool_type: "teacher" | "student";
}

export interface ToolFavoriteRemovedProperties {
  /**
   * The page or module where the favorite action occurred.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | homepage_recommended_tools, student_tools, teacher_tools, homepage_collections, collections |
   */
  favorite_surface:
    | "homepage_recommended_tools"
    | "student_tools"
    | "teacher_tools"
    | "homepage_collections"
    | "collections";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface ToolFavoritedProperties {
  /**
   * The page or module where the favorite action occurred.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | homepage_recommended_tools, student_tools, teacher_tools, homepage_collections, collections |
   */
  favorite_surface:
    | "homepage_recommended_tools"
    | "student_tools"
    | "teacher_tools"
    | "homepage_collections"
    | "collections";
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface ToolSortedProperties {
  /**
   * The page where the sort was applied.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | teacher_tools, student_tools |
   */
  sort_surface: "teacher_tools" | "student_tools";
  /**
   * The sort order selected by the user.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | popular, A-Z, Z-A |
   */
  sort_value: "popular" | "A-Z" | "Z-A";
}

export interface ToolSuggestionClickedProperties {
  /**
   * Chat surface the suggestion rendered on: raina, tool, or insights. Filter to raina for the Raina discovery funnel.
   */
  chat_surface: string;
  /**
   * Assistant message the suggestion rendered under.
   */
  message_id?: string;
  /**
   * Zero-based position of the tapped suggestion in its batch.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  suggestion_index?: number;
  /**
   * Which suggestion surface this is: a follow-up prompt or the tool discovery pill.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | tool_pill, followup |
   */
  suggestion_type: "tool_pill" | "followup";
  /**
   * Raina thread id.
   */
  thread_id?: string;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id?: string;
  /**
   * Matched tool slug; only set when suggestion_type is tool_pill.
   */
  tool_slug?: string;
}

export interface ToolSuggestionShownProperties {
  /**
   * Chat surface the suggestion rendered on: raina, tool, or insights. Filter to raina for the Raina discovery funnel.
   */
  chat_surface: string;
  /**
   * Assistant message the suggestion rendered under.
   */
  message_id?: string;
  /**
   * How many suggestions rendered together in this batch.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  suggestion_count?: number;
  /**
   * Which suggestion surface this is: a follow-up prompt or the tool discovery pill.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | tool_pill, followup |
   */
  suggestion_type: "tool_pill" | "followup";
  /**
   * Raina thread id.
   */
  thread_id?: string;
  /**
   * Specifies the tool customization id (UUID)
   */
  tool_customization_id?: string;
  /**
   * Matched tool slug; only set when suggestion_type is tool_pill.
   */
  tool_slug?: string;
}

export interface ToolViewEditedProperties {
  /**
   * The action taken to change how a tool list is displayed within a module.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | tool_list_expanded, tool_list_collapsed |
   */
  tool_view_edit_action: "tool_list_expanded" | "tool_list_collapsed";
  /**
   * The page or module where the tool view edit occurred.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | homepage_collections_module |
   */
  tool_view_surface: "homepage_collections_module";
}

export interface ToolbarMenuOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Which editor the event came from, so one event covers documents and decks.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | document, presentation |
   */
  artifact_type: "document" | "presentation";
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id?: string;
  editor_mode?: any;
  /**
   * Presentation Studio deck identifier. This is the createPresentation toolCallId, and it joins to presentation_decks.tool_call_id in the warehouse, which is how a funnel here reaches the deck's brief content. Not the deck row id, which does not exist until the first autosave.
   */
  presentation_id?: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
  /**
   * The toolbar dropdown or panel that opened.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | heading, text_style, font_family, font_size, text_color, highlight, alignment, list, link, table, more, view_mode, export |
   */
  toolbar_menu:
    | "heading"
    | "text_style"
    | "font_family"
    | "font_size"
    | "text_color"
    | "highlight"
    | "alignment"
    | "list"
    | "link"
    | "table"
    | "more"
    | "view_mode"
    | "export";
}

export interface UsageLimitImpressionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * This describes the surface where the usage limit banner is show to the user.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | tool_form, chat_input, raina_input, homepage_raina |
   */
  usage_banner_surface?: "tool_form" | "chat_input" | "raina_input" | "homepage_raina";
  /**
   * Free + non-trial users have usage limits. The banner shows when they hit each threshold: 75, 90, 100.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | 75, 90, 100, 80 |
   */
  usage_threshold?: "75" | "90" | "100" | "80";
}

export interface UserOrgRoleUpdatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * UUID of an organization
   */
  org_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  user_id: string;
  /**
   * Role of the user. See `user_role` in `users` table.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | student, teacher, org_admin, internal, superuser |
   */
  user_role: "student" | "teacher" | "org_admin" | "internal" | "superuser";
}

export interface UserSiteRoleUpdatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The institution (school) id when recipient_scope_type is school; absent for org_wide.
   */
  institution_id: string;
  /**
   * Describes the user's access within a site/institution. See `institution_role_type` enum.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | teacher, admin |
   */
  institution_user_role: "teacher" | "admin";
  /**
   * UUID of an organization
   */
  org_id: string;
  /**
   * UUID of a user.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  user_id: string;
}

export interface VideoPlayedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The page a user is on when they play the video.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | homepage_flex_card, workflows, homepage_recommended_tools_module |
   */
  video_surface: "homepage_flex_card" | "workflows" | "homepage_recommended_tools_module";
  /**
   * This is the title of the video in English.
   */
  video_title: string;
  /**
   * This shows if we differentiate videos for different user types.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | all, teacher, admin |
   */
  video_user_context: "all" | "teacher" | "admin";
}

export interface ViewModeChangedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
  /**
   * The layout before the switch.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | paged, pageless |
   */
  view_mode_from: "paged" | "pageless";
  /**
   * The layout after the switch.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | paged, pageless |
   */
  view_mode_to: "paged" | "pageless";
}

export interface PageProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AiOutputSubmitFeedback implements BaseEvent {
  event_type = 'AIOutput:SubmitFeedback';

  constructor(
    public event_properties: AiOutputSubmitFeedbackProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AlertCategoryToggled implements BaseEvent {
  event_type = 'Alert Category Toggled';

  constructor(
    public event_properties?: AlertCategoryToggledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AskUserQuestionAnswered implements BaseEvent {
  event_type = 'Ask User Question Answered';

  constructor(
    public event_properties: AskUserQuestionAnsweredProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AskUserQuestionSkipped implements BaseEvent {
  event_type = 'Ask User Question Skipped';

  constructor(
    public event_properties: AskUserQuestionSkippedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AskUserQuestionsImpression implements BaseEvent {
  event_type = 'Ask User Questions Impression';

  constructor(
    public event_properties: AskUserQuestionsImpressionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AskUserQuestionsSubmitted implements BaseEvent {
  event_type = 'Ask User Questions Submitted';

  constructor(
    public event_properties: AskUserQuestionsSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BlockInserted implements BaseEvent {
  event_type = 'Block Inserted';

  constructor(
    public event_properties: BlockInsertedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BrandingImpression implements BaseEvent {
  event_type = 'Branding Impression';

  constructor(
    public event_properties: BrandingImpressionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BrandingLinkNavigated implements BaseEvent {
  event_type = 'Branding Link Navigated';

  constructor(
    public event_properties: BrandingLinkNavigatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BreadcrumbNavigated implements BaseEvent {
  event_type = 'Breadcrumb Navigated';

  constructor(
    public event_properties: BreadcrumbNavigatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatGenerationStopped implements BaseEvent {
  event_type = 'Chat Generation Stopped';

  constructor(
    public event_properties: ChatGenerationStoppedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatMessageSubmitted implements BaseEvent {
  event_type = 'Chat Message Submitted';

  constructor(
    public event_properties: ChatMessageSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContentCopied implements BaseEvent {
  event_type = 'Content Copied';

  constructor(
    public event_properties: ContentCopiedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContentFormatted implements BaseEvent {
  event_type = 'Content Formatted';

  constructor(
    public event_properties: ContentFormattedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CustomStudentToolDeleted implements BaseEvent {
  event_type = 'Custom Student Tool Deleted';

  constructor(
    public event_properties: CustomStudentToolDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CustomStudentToolOpened implements BaseEvent {
  event_type = 'Custom Student Tool Opened';

  constructor(
    public event_properties: CustomStudentToolOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CustomStudentToolPromoted implements BaseEvent {
  event_type = 'Custom Student Tool Promoted';

  constructor(
    public event_properties: CustomStudentToolPromotedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CustomStudentToolSaved implements BaseEvent {
  event_type = 'Custom Student Tool Saved';

  constructor(
    public event_properties: CustomStudentToolSavedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CustomTeacherToolOpened implements BaseEvent {
  event_type = 'Custom Teacher Tool Opened';

  constructor(
    public event_properties: CustomTeacherToolOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CustomTeacherToolPromoted implements BaseEvent {
  event_type = 'Custom Teacher Tool Promoted';

  constructor(
    public event_properties: CustomTeacherToolPromotedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CustomToolPromoteDismissed implements BaseEvent {
  event_type = 'Custom Tool Promote Dismissed';

  constructor(
    public event_properties: CustomToolPromoteDismissedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentClosed implements BaseEvent {
  event_type = 'Document Closed';

  constructor(
    public event_properties: DocumentClosedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentEdited implements BaseEvent {
  event_type = 'Document Edited';

  constructor(
    public event_properties: DocumentEditedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentExported implements BaseEvent {
  event_type = 'Document Exported';

  constructor(
    public event_properties: DocumentExportedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentGenerated implements BaseEvent {
  event_type = 'Document Generated';

  constructor(
    public event_properties: DocumentGeneratedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentOpened implements BaseEvent {
  event_type = 'Document Opened';

  constructor(
    public event_properties: DocumentOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentPreviewExpanded implements BaseEvent {
  event_type = 'Document Preview Expanded';

  constructor(
    public event_properties: DocumentPreviewExpandedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentPreviewPageChanged implements BaseEvent {
  event_type = 'Document Preview Page Changed';

  constructor(
    public event_properties: DocumentPreviewPageChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentRenamed implements BaseEvent {
  event_type = 'Document Renamed';

  constructor(
    public event_properties: DocumentRenamedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentTranslated implements BaseEvent {
  event_type = 'Document Translated';

  constructor(
    public event_properties: DocumentTranslatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EnterpriseQuotePageOpened implements BaseEvent {
  event_type = 'Enterprise Quote Page Opened';

  constructor(
    public event_properties: EnterpriseQuotePageOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EnterpriseStudentToolDeleted implements BaseEvent {
  event_type = 'Enterprise Student Tool Deleted';

  constructor(
    public event_properties: EnterpriseStudentToolDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EnterpriseStudentToolOpened implements BaseEvent {
  event_type = 'Enterprise Student Tool Opened';

  constructor(
    public event_properties: EnterpriseStudentToolOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EnterpriseStudentToolPreviewed implements BaseEvent {
  event_type = 'Enterprise Student Tool Previewed';

  constructor(
    public event_properties: EnterpriseStudentToolPreviewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EnterpriseStudentToolUpdated implements BaseEvent {
  event_type = 'Enterprise Student Tool Updated';

  constructor(
    public event_properties: EnterpriseStudentToolUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EnterpriseTeacherToolDeleted implements BaseEvent {
  event_type = 'Enterprise Teacher Tool Deleted';

  constructor(
    public event_properties: EnterpriseTeacherToolDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EnterpriseTeacherToolOpened implements BaseEvent {
  event_type = 'Enterprise Teacher Tool Opened';

  constructor(
    public event_properties: EnterpriseTeacherToolOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EnterpriseTeacherToolPreviewed implements BaseEvent {
  event_type = 'Enterprise Teacher Tool Previewed';

  constructor(
    public event_properties: EnterpriseTeacherToolPreviewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EnterpriseTeacherToolUpdated implements BaseEvent {
  event_type = 'Enterprise Teacher Tool Updated';

  constructor(
    public event_properties: EnterpriseTeacherToolUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FilterAction implements BaseEvent {
  event_type = 'Filter Action';

  constructor(
    public event_properties: FilterActionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ImageAdded implements BaseEvent {
  event_type = 'Image Added';

  constructor(
    public event_properties?: ImageAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ImageExported implements BaseEvent {
  event_type = 'Image Exported';

  constructor(
    public event_properties: ImageExportedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ImageGenUpgradeAction implements BaseEvent {
  event_type = 'Image Gen Upgrade Action';

  constructor(
    public event_properties: ImageGenUpgradeActionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ImageReported implements BaseEvent {
  event_type = 'Image Reported';

  constructor(
    public event_properties: ImageReportedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InspirationGalleryOpened implements BaseEvent {
  event_type = 'Inspiration Gallery Opened';

  constructor(
    public event_properties: InspirationGalleryOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InspirationGallerySearched implements BaseEvent {
  event_type = 'Inspiration Gallery Searched';

  constructor(
    public event_properties: InspirationGallerySearchedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InspirationPromptApplied implements BaseEvent {
  event_type = 'Inspiration Prompt Applied';

  constructor(
    public event_properties: InspirationPromptAppliedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminDemoOrgAccessed implements BaseEvent {
  event_type = 'Internal Admin Demo Org Accessed';

  constructor(
    public event_properties: InternalAdminDemoOrgAccessedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminDemoOrgCreated implements BaseEvent {
  event_type = 'Internal Admin Demo Org Created';

  constructor(
    public event_properties: InternalAdminDemoOrgCreatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminDemoOrgCreationStarted implements BaseEvent {
  event_type = 'Internal Admin Demo Org Creation Started';

  constructor(
    public event_properties?: InternalAdminDemoOrgCreationStartedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminDemoOrgDeleted implements BaseEvent {
  event_type = 'Internal Admin Demo Org Deleted';

  constructor(
    public event_properties: InternalAdminDemoOrgDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminDemoOrgFeatureSettingsUpdated implements BaseEvent {
  event_type = 'Internal Admin Demo Org Feature Settings Updated';

  constructor(
    public event_properties: InternalAdminDemoOrgFeatureSettingsUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminDemoOrgToolAccessUpdated implements BaseEvent {
  event_type = 'Internal Admin Demo Org Tool Access Updated';

  constructor(
    public event_properties: InternalAdminDemoOrgToolAccessUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminOrganizationBulkActionsOpened implements BaseEvent {
  event_type = 'Internal Admin Organization Bulk Actions Opened';

  constructor(
    public event_properties: InternalAdminOrganizationBulkActionsOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminOrganizationFeatureSettingsUpdated implements BaseEvent {
  event_type = 'Internal Admin Organization Feature Settings Updated';

  constructor(
    public event_properties: InternalAdminOrganizationFeatureSettingsUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminOrganizationIntegrationsOpened implements BaseEvent {
  event_type = 'Internal Admin Organization Integrations Opened';

  constructor(
    public event_properties: InternalAdminOrganizationIntegrationsOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminOrganizationNotesOpened implements BaseEvent {
  event_type = 'Internal Admin Organization Notes Opened';

  constructor(
    public event_properties: InternalAdminOrganizationNotesOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminOrganizationOpened implements BaseEvent {
  event_type = 'Internal Admin Organization Opened';

  constructor(
    public event_properties: InternalAdminOrganizationOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminOrganizationReportingOpened implements BaseEvent {
  event_type = 'Internal Admin Organization Reporting Opened';

  constructor(
    public event_properties: InternalAdminOrganizationReportingOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminOrganizationSyncHistoryOpened implements BaseEvent {
  event_type = 'Internal Admin Organization Sync History Opened';

  constructor(
    public event_properties: InternalAdminOrganizationSyncHistoryOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminOrganizationToolAccessOpened implements BaseEvent {
  event_type = 'Internal Admin Organization Tool Access Opened';

  constructor(
    public event_properties: InternalAdminOrganizationToolAccessOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminOrganizationToolAccessUpdated implements BaseEvent {
  event_type = 'Internal Admin Organization Tool Access Updated';

  constructor(
    public event_properties: InternalAdminOrganizationToolAccessUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminOrganizationUsersOpened implements BaseEvent {
  event_type = 'Internal Admin Organization Users Opened';

  constructor(
    public event_properties: InternalAdminOrganizationUsersOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminResetPasswordEmailSent implements BaseEvent {
  event_type = 'Internal Admin Reset Password Email Sent';

  constructor(
    public event_properties: InternalAdminResetPasswordEmailSentProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminUserDeleted implements BaseEvent {
  event_type = 'Internal Admin User Deleted';

  constructor(
    public event_properties: InternalAdminUserDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminUserEventSyncsOpened implements BaseEvent {
  event_type = 'Internal Admin User Event Syncs Opened';

  constructor(
    public event_properties: InternalAdminUserEventSyncsOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminUserFeatureAccessUpdated implements BaseEvent {
  event_type = 'Internal Admin User Feature Access Updated';

  constructor(
    public event_properties: InternalAdminUserFeatureAccessUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminUserImpersonated implements BaseEvent {
  event_type = 'Internal Admin User Impersonated';

  constructor(
    public event_properties: InternalAdminUserImpersonatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminUserMigrated implements BaseEvent {
  event_type = 'Internal Admin User Migrated';

  constructor(
    public event_properties: InternalAdminUserMigratedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminUserMigrationSearched implements BaseEvent {
  event_type = 'Internal Admin User Migration Searched';

  constructor(
    public event_properties: InternalAdminUserMigrationSearchedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminUserRemoved implements BaseEvent {
  event_type = 'Internal Admin User Removed';

  constructor(
    public event_properties: InternalAdminUserRemovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminUserRoleUpdated implements BaseEvent {
  event_type = 'Internal Admin User Role Updated';

  constructor(
    public event_properties: InternalAdminUserRoleUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ManualSsoSyncTriggered implements BaseEvent {
  event_type = 'Manual SSO Sync Triggered';

  constructor(
    public event_properties: ManualSsoSyncTriggeredProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ModerationSettingsLeftUnsaved implements BaseEvent {
  event_type = 'Moderation Settings Left Unsaved';

  constructor(
    public event_properties?: ModerationSettingsLeftUnsavedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ModuleRemoved implements BaseEvent {
  event_type = 'Module Removed';

  constructor(
    public event_properties: ModuleRemovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NavigationAction implements BaseEvent {
  event_type = 'Navigation Action';

  constructor(
    public event_properties: NavigationActionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OnboardingStepInteraction implements BaseEvent {
  event_type = 'Onboarding Step Interaction';

  constructor(
    public event_properties: OnboardingStepInteractionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OrgCustomizationSaved implements BaseEvent {
  event_type = 'Org Customization Saved';

  constructor(
    public event_properties: OrgCustomizationSavedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PresentationClosed implements BaseEvent {
  event_type = 'Presentation Closed';

  constructor(
    public event_properties: PresentationClosedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PresentationExported implements BaseEvent {
  event_type = 'Presentation Exported';

  constructor(
    public event_properties?: PresentationExportedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PresentationGenerated implements BaseEvent {
  event_type = 'Presentation Generated';

  constructor(
    public event_properties: PresentationGeneratedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PresentationOpened implements BaseEvent {
  event_type = 'Presentation Opened';

  constructor(
    public event_properties: PresentationOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PresentationRefined implements BaseEvent {
  event_type = 'Presentation Refined';

  constructor(
    public event_properties?: PresentationRefinedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PresentationRequested implements BaseEvent {
  event_type = 'Presentation Requested';

  constructor(
    public event_properties?: PresentationRequestedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PrintableExported implements BaseEvent {
  event_type = 'Printable Exported';

  constructor(
    public event_properties: PrintableExportedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PrintableRevised implements BaseEvent {
  event_type = 'Printable Revised';

  constructor(
    public event_properties: PrintableRevisedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProfileUpdateClosed implements BaseEvent {
  event_type = 'Profile Update Closed';

  constructor(
    public event_properties: ProfileUpdateClosedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProfileUpdateImpression implements BaseEvent {
  event_type = 'Profile Update Impression';

  constructor(
    public event_properties: ProfileUpdateImpressionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProfileUpdated implements BaseEvent {
  event_type = 'Profile Updated';

  constructor(
    public event_properties: ProfileUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PromptStarterImpression implements BaseEvent {
  event_type = 'Prompt Starter Impression';

  constructor(
    public event_properties: PromptStarterImpressionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PromptStarterMenuItemApplied implements BaseEvent {
  event_type = 'Prompt Starter Menu Item Applied';

  constructor(
    public event_properties: PromptStarterMenuItemAppliedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PromptStarterMenuOpened implements BaseEvent {
  event_type = 'Prompt Starter Menu Opened';

  constructor(
    public event_properties: PromptStarterMenuOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RecommendationsClicked implements BaseEvent {
  event_type = 'Recommendations Clicked';

  constructor(
    public event_properties: RecommendationsClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RecommendationsImpression implements BaseEvent {
  event_type = 'Recommendations Impression';

  constructor(
    public event_properties: RecommendationsImpressionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ResourceFileUploadCompleted implements BaseEvent {
  event_type = 'Resource File Upload Completed';

  constructor(
    public event_properties: ResourceFileUploadCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ResourceFileUploadInitiated implements BaseEvent {
  event_type = 'Resource File Upload Initiated';

  constructor(
    public event_properties: ResourceFileUploadInitiatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ResourceLibraryFiltered implements BaseEvent {
  event_type = 'Resource Library Filtered';

  constructor(
    public event_properties: ResourceLibraryFilteredProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ResourceLibrarySearched implements BaseEvent {
  event_type = 'Resource Library Searched';

  constructor(
    public event_properties: ResourceLibrarySearchedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ResourceOpened implements BaseEvent {
  event_type = 'Resource Opened';

  constructor(
    public event_properties: ResourceOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ResourcePreviewOpened implements BaseEvent {
  event_type = 'Resource Preview Opened';

  constructor(
    public event_properties: ResourcePreviewOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ResourceReferenced implements BaseEvent {
  event_type = 'Resource Referenced';

  constructor(
    public event_properties: ResourceReferencedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ResourceRemoved implements BaseEvent {
  event_type = 'Resource Removed';

  constructor(
    public event_properties: ResourceRemovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ResourceSaved implements BaseEvent {
  event_type = 'Resource Saved';

  constructor(
    public event_properties: ResourceSavedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SsoIntegrationGuideOpened implements BaseEvent {
  event_type = 'SSO Integration Guide Opened';

  constructor(
    public event_properties: SsoIntegrationGuideOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class StartQuizGenerated implements BaseEvent {
  event_type = 'Start Quiz Generated';

  constructor(
    public event_properties: StartQuizGeneratedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SubscriptionSubscribeButtonClicked implements BaseEvent {
  event_type = 'Subscription: Subscribe Button Clicked';

  constructor(
    public event_properties?: SubscriptionSubscribeButtonClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TableEdited implements BaseEvent {
  event_type = 'Table Edited';

  constructor(
    public event_properties: TableEditedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TableFiltered implements BaseEvent {
  event_type = 'Table Filtered';

  constructor(
    public event_properties: TableFilteredProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TableFiltersCleared implements BaseEvent {
  event_type = 'Table Filters Cleared';

  constructor(
    public event_properties: TableFiltersClearedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TablePaginated implements BaseEvent {
  event_type = 'Table Paginated';

  constructor(
    public event_properties: TablePaginatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TableRowExpansionChanged implements BaseEvent {
  event_type = 'Table Row Expansion Changed';

  constructor(
    public event_properties: TableRowExpansionChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TableRowSelectionChanged implements BaseEvent {
  event_type = 'Table Row Selection Changed';

  constructor(
    public event_properties: TableRowSelectionChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TableSearched implements BaseEvent {
  event_type = 'Table Searched';

  constructor(
    public event_properties: TableSearchedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TableSorted implements BaseEvent {
  event_type = 'Table Sorted';

  constructor(
    public event_properties: TableSortedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ThreadDeleted implements BaseEvent {
  event_type = 'Thread Deleted';

  constructor(
    public event_properties: ThreadDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ThreadFavoriteRemoved implements BaseEvent {
  event_type = 'Thread Favorite Removed';

  constructor(
    public event_properties: ThreadFavoriteRemovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ThreadFavorited implements BaseEvent {
  event_type = 'Thread Favorited';

  constructor(
    public event_properties: ThreadFavoritedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ThreadOpened implements BaseEvent {
  event_type = 'Thread Opened';

  constructor(
    public event_properties: ThreadOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ThreadPreviewed implements BaseEvent {
  event_type = 'Thread Previewed';

  constructor(
    public event_properties: ThreadPreviewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ThreadSharingEdited implements BaseEvent {
  event_type = 'Thread Sharing Edited';

  constructor(
    public event_properties: ThreadSharingEditedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ThreadTitleEdited implements BaseEvent {
  event_type = 'Thread Title Edited';

  constructor(
    public event_properties: ThreadTitleEditedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ToolCallOutputGenerated implements BaseEvent {
  event_type = 'Tool Call Output Generated';

  constructor(
    public event_properties: ToolCallOutputGeneratedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ToolCardClicked implements BaseEvent {
  event_type = 'Tool Card Clicked';

  constructor(
    public event_properties: ToolCardClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ToolFavoriteRemoved implements BaseEvent {
  event_type = 'Tool Favorite Removed';

  constructor(
    public event_properties: ToolFavoriteRemovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ToolFavorited implements BaseEvent {
  event_type = 'Tool Favorited';

  constructor(
    public event_properties: ToolFavoritedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ToolSorted implements BaseEvent {
  event_type = 'Tool Sorted';

  constructor(
    public event_properties: ToolSortedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ToolSuggestionClicked implements BaseEvent {
  event_type = 'Tool Suggestion Clicked';

  constructor(
    public event_properties: ToolSuggestionClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ToolSuggestionShown implements BaseEvent {
  event_type = 'Tool Suggestion Shown';

  constructor(
    public event_properties: ToolSuggestionShownProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ToolViewEdited implements BaseEvent {
  event_type = 'Tool View Edited';

  constructor(
    public event_properties: ToolViewEditedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ToolbarMenuOpened implements BaseEvent {
  event_type = 'Toolbar Menu Opened';

  constructor(
    public event_properties: ToolbarMenuOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UsageLimitImpression implements BaseEvent {
  event_type = 'Usage Limit Impression';

  constructor(
    public event_properties?: UsageLimitImpressionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UserOrgRoleUpdated implements BaseEvent {
  event_type = 'User Org Role Updated';

  constructor(
    public event_properties: UserOrgRoleUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UserSiteRoleUpdated implements BaseEvent {
  event_type = 'User Site Role Updated';

  constructor(
    public event_properties: UserSiteRoleUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class VideoPlayed implements BaseEvent {
  event_type = 'Video Played';

  constructor(
    public event_properties: VideoPlayedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ViewModeChanged implements BaseEvent {
  event_type = 'View Mode Changed';

  constructor(
    public event_properties: ViewModeChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * AIOutput:SubmitFeedback
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/AIOutput%3ASubmitFeedback)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  aiOutputSubmitFeedback(
    properties: AiOutputSubmitFeedbackProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiOutputSubmitFeedback(properties), options);
  }

  /**
   * Alert Category Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Alert%20Category%20Toggled)
   *
   * A moderation-alert email category was toggled on or off for an org (either the legacy org-wide alerting card or the school-scoped alerting UI).
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  alertCategoryToggled(
    properties?: AlertCategoryToggledProperties,
    options?: EventOptions,
  ) {
    return this.track(new AlertCategoryToggled(properties), options);
  }

  /**
   * Ask User Question Answered
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Ask%20User%20Question%20Answered)
   *
   * A teacher settled one question in an askUserQuestion round with an answer: a single-select option tap, a single-select write-in submit, or a multi-select Next/Done confirm.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  askUserQuestionAnswered(
    properties: AskUserQuestionAnsweredProperties,
    options?: EventOptions,
  ) {
    return this.track(new AskUserQuestionAnswered(properties), options);
  }

  /**
   * Ask User Question Skipped
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Ask%20User%20Question%20Skipped)
   *
   * One question in an askUserQuestion round ended skipped: a Skip this question tap, or still unanswered when the round was submitted.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  askUserQuestionSkipped(
    properties: AskUserQuestionSkippedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AskUserQuestionSkipped(properties), options);
  }

  /**
   * Ask User Questions Impression
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Ask%20User%20Questions%20Impression)
   *
   * A round of askUserQuestion clarifying questions rendered above the Raina composer. Fires once per round (per `tool_call_id`). A reload of a pending round fires it again, so count unique `tool_call_id` for round-level denominators.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  askUserQuestionsImpression(
    properties: AskUserQuestionsImpressionProperties,
    options?: EventOptions,
  ) {
    return this.track(new AskUserQuestionsImpression(properties), options);
  }

  /**
   * Ask User Questions Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Ask%20User%20Questions%20Submitted)
   *
   * The round's answers were successfully posted back to the model, by answering the last question or via the header X. Fires on success only, so a retried failed submit counts once.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  askUserQuestionsSubmitted(
    properties: AskUserQuestionsSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AskUserQuestionsSubmitted(properties), options);
  }

  /**
   * Block Inserted
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Block%20Inserted)
   *
   * A teacher inserted a table, equation, image or link into a Studio document. Deck images report Image Added instead.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  blockInserted(
    properties: BlockInsertedProperties,
    options?: EventOptions,
  ) {
    return this.track(new BlockInserted(properties), options);
  }

  /**
   * Branding Impression
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Branding%20Impression)
   *
   * This event represents when a user is exposed to a branding element within the MagicSchoolAi application. It is triggered each time a branding asset (e.g. Bulletin Board on the Homepage), is displayed to the user. This event helps track the visibility and reach of branding efforts under the PRISE team category.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  brandingImpression(
    properties: BrandingImpressionProperties,
    options?: EventOptions,
  ) {
    return this.track(new BrandingImpression(properties), options);
  }

  /**
   * Branding Link Navigated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Branding%20Link%20Navigated)
   *
   * This event is triggered when a user clicks on a link within the Bulletin Board Module on the Homeroom page.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  brandingLinkNavigated(
    properties: BrandingLinkNavigatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new BrandingLinkNavigated(properties), options);
  }

  /**
   * Breadcrumb Navigated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Breadcrumb%20Navigated)
   *
   * A teacher used a link crumb in any breadcrumb trail in the teacher app or LTI. The current-page crumb is not clickable and never fires this.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  breadcrumbNavigated(
    properties: BreadcrumbNavigatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new BreadcrumbNavigated(properties), options);
  }

  /**
   * Chat Generation Stopped
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Chat%20Generation%20Stopped)
   *
   * Fires when a user clicks the Stop control to interrupt an in-progress chat generation, tagged with the chat surface. Fires only on a genuine Stop click, never on a programmatic abort such as switching threads, unmounting, or navigating away.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  chatGenerationStopped(
    properties: ChatGenerationStoppedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatGenerationStopped(properties), options);
  }

  /**
   * Chat Message Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Chat%20Message%20Submitted)
   *
   * Fires when a teacher submits a message from a chat input (Raina, tool, or insights surface; chat_surface carries the surface). Client-side, once per send. Purpose: anchors journey time at true send instead of route-trace start, and gives intent-to-artifact completion a client-side denominator that survives the form-flow removal (PEN-810). Named Submitted, not Sent: the legacy Chat Message Sent event (2023 chat surface, last seen Jun 2024) is a dead series with different semantics and must not be spliced. Capture validation denominator: raina:generate root spans in Braintrust, per the PEN-808 suggestion-events pattern. Properties (snake_case, matching the Tool Call family): thread_id, chat_surface, message_id.
   *
   * @param properties The event's properties (e.g. chat_surface)
   * @param options Amplitude event options.
   */
  chatMessageSubmitted(
    properties: ChatMessageSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatMessageSubmitted(properties), options);
  }

  /**
   * Content Copied
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Content%20Copied)
   *
   * A teacher copied or cut a selection out of the Studio document editor. Keyboard and context-menu copy are one browser event, so they are not told apart. The header Copy button reports Document Exported instead.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  contentCopied(
    properties: ContentCopiedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContentCopied(properties), options);
  }

  /**
   * Content Formatted
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Content%20Formatted)
   *
   * A teacher applied a formatting option in the Studio document editor or the slide text toolbar, from the toolbar or its keyboard shortcut. Carries the chosen option and the one it replaced, never document text. On decks it fires alongside Presentation Refined, which keeps counting the edit. Font size stepper clicks within a second are one event.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  contentFormatted(
    properties: ContentFormattedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContentFormatted(properties), options);
  }

  /**
   * Custom Student Tool Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Custom%20Student%20Tool%20Deleted)
   *
   * Triggered when a teacher deletes a custom student tool via the Actions dropdown
   *
   * @param properties The event's properties (e.g. tool_customization_id)
   * @param options Amplitude event options.
   */
  customStudentToolDeleted(
    properties: CustomStudentToolDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CustomStudentToolDeleted(properties), options);
  }

  /**
   * Custom Student Tool Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Custom%20Student%20Tool%20Opened)
   *
   * Fires when viewing a custom student tool.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  customStudentToolOpened(
    properties: CustomStudentToolOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CustomStudentToolOpened(properties), options);
  }

  /**
   * Custom Student Tool Promoted
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Custom%20Student%20Tool%20Promoted)
   *
   * This event captures when a teacher/educator promotes a custom student tool within the student interface to a higher visibility or priority status.
   *
   * Owner: Caroline Humphrey
   *
   * @param properties The event's properties (e.g. tool_customization_id)
   * @param options Amplitude event options.
   */
  customStudentToolPromoted(
    properties: CustomStudentToolPromotedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CustomStudentToolPromoted(properties), options);
  }

  /**
   * Custom Student Tool Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Custom%20Student%20Tool%20Saved)
   *
   * Fires when a teacher saves a student tool.
   *
   * @param properties The event's properties (e.g. tool_customization_id)
   * @param options Amplitude event options.
   */
  customStudentToolSaved(
    properties: CustomStudentToolSavedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CustomStudentToolSaved(properties), options);
  }

  /**
   * Custom Teacher Tool Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Custom%20Teacher%20Tool%20Opened)
   *
   * Fires when viewing a custom teacher tool.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  customTeacherToolOpened(
    properties: CustomTeacherToolOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CustomTeacherToolOpened(properties), options);
  }

  /**
   * Custom Teacher Tool Promoted
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Custom%20Teacher%20Tool%20Promoted)
   *
   * This event captures when a teacher/educator promotes a custom teacher tool within the teacher interface to a higher visibility or priority status.
   *
   * @param properties The event's properties (e.g. tool_customization_id)
   * @param options Amplitude event options.
   */
  customTeacherToolPromoted(
    properties: CustomTeacherToolPromotedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CustomTeacherToolPromoted(properties), options);
  }

  /**
   * Custom Tool Promote Dismissed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Custom%20Tool%20Promote%20Dismissed)
   *
   * Triggered when a user dismisses the confirmation modal to move a custom tool to the library.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  customToolPromoteDismissed(
    properties: CustomToolPromoteDismissedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CustomToolPromoteDismissed(properties), options);
  }

  /**
   * Document Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Document%20Closed)
   *
   * The Studio panel stopped showing a document: closed with the header button, dismissed, or replaced by another artifact. time_open_ms is how long it was open.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  documentClosed(
    properties: DocumentClosedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentClosed(properties), options);
  }

  /**
   * Document Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Document%20Edited)
   *
   * A Studio document changed. Teacher edits are grouped after 2 s of quiet and carry the last edit's type and source; a paste fires on its own, immediately, with what the clipboard held. AI edits fire with edit_source llm.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  documentEdited(
    properties: DocumentEditedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentEdited(properties), options);
  }

  /**
   * Document Exported
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Document%20Exported)
   *
   * A Studio document export, print or copy finished. Fires on the outcome, not the click, so export_status tells succeeded, failed, and oauth_cancelled apart. oauth_cancelled means the teacher closed or declined the Google sign-in popup. For print, succeeded means the print dialog opened; the browser does not say whether the teacher printed.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  documentExported(
    properties: DocumentExportedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentExported(properties), options);
  }

  /**
   * Document Generated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Document%20Generated)
   *
   * A Studio document generation finished, with its outcome in generation_status. The top of every document funnel.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  documentGenerated(
    properties: DocumentGeneratedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentGenerated(properties), options);
  }

  /**
   * Document Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Document%20Opened)
   *
   * Records Studio documents being opened, either by the user or automatically by the app.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  documentOpened(
    properties: DocumentOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentOpened(properties), options);
  }

  /**
   * Document Preview Expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Document%20Preview%20Expanded)
   *
   * A teacher expanded the document card in the chat thread to read the current page whole.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  documentPreviewExpanded(
    properties: DocumentPreviewExpandedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentPreviewExpanded(properties), options);
  }

  /**
   * Document Preview Page Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Document%20Preview%20Page%20Changed)
   *
   * A teacher paged through the document card in the chat thread. Rapid clicks are grouped into one event carrying the page they landed on.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  documentPreviewPageChanged(
    properties: DocumentPreviewPageChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentPreviewPageChanged(properties), options);
  }

  /**
   * Document Renamed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Document%20Renamed)
   *
   * A teacher saved a new title for a Studio document from the editor header.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  documentRenamed(
    properties: DocumentRenamedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentRenamed(properties), options);
  }

  /**
   * Document Translated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Document%20Translated)
   *
   * A translated Studio document landed. translate_method tells the Translate button from a typed chat request.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  documentTranslated(
    properties: DocumentTranslatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentTranslated(properties), options);
  }

  /**
   * Enterprise Quote Page Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Enterprise%20Quote%20Page%20Opened)
   *
   * Fires when a Plus teacher clicks Get in touch after reaching an image or figure limit and opens the enterprise quote page, before any quote is submitted.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  enterpriseQuotePageOpened(
    properties: EnterpriseQuotePageOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EnterpriseQuotePageOpened(properties), options);
  }

  /**
   * Enterprise Student Tool Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Enterprise%20Student%20Tool%20Deleted)
   *
   * Triggered when a user deletes a student tool within an enterprise account.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  enterpriseStudentToolDeleted(
    properties: EnterpriseStudentToolDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EnterpriseStudentToolDeleted(properties), options);
  }

  /**
   * Enterprise Student Tool Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Enterprise%20Student%20Tool%20Opened)
   *
   * Fires when viewing a student tool.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  enterpriseStudentToolOpened(
    properties: EnterpriseStudentToolOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EnterpriseStudentToolOpened(properties), options);
  }

  /**
   * Enterprise Student Tool Previewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Enterprise%20Student%20Tool%20Previewed)
   *
   * Triggered when an org admin previews an enterprise student tool.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  enterpriseStudentToolPreviewed(
    properties: EnterpriseStudentToolPreviewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EnterpriseStudentToolPreviewed(properties), options);
  }

  /**
   * Enterprise Student Tool Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Enterprise%20Student%20Tool%20Updated)
   *
   * Triggered when an enterprise student tool is changed by an admin.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  enterpriseStudentToolUpdated(
    properties: EnterpriseStudentToolUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EnterpriseStudentToolUpdated(properties), options);
  }

  /**
   * Enterprise Teacher Tool Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Enterprise%20Teacher%20Tool%20Deleted)
   *
   * Triggered when a user deletes a teacher tool within an enterprise account.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  enterpriseTeacherToolDeleted(
    properties: EnterpriseTeacherToolDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EnterpriseTeacherToolDeleted(properties), options);
  }

  /**
   * Enterprise Teacher Tool Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Enterprise%20Teacher%20Tool%20Opened)
   *
   * Fires when viewing a teacher tool.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  enterpriseTeacherToolOpened(
    properties: EnterpriseTeacherToolOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EnterpriseTeacherToolOpened(properties), options);
  }

  /**
   * Enterprise Teacher Tool Previewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Enterprise%20Teacher%20Tool%20Previewed)
   *
   * Triggered when an org admin previews an enterprise teacher tool.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  enterpriseTeacherToolPreviewed(
    properties: EnterpriseTeacherToolPreviewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EnterpriseTeacherToolPreviewed(properties), options);
  }

  /**
   * Enterprise Teacher Tool Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Enterprise%20Teacher%20Tool%20Updated)
   *
   * Triggered when an enterprise teacher tool is updated.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  enterpriseTeacherToolUpdated(
    properties: EnterpriseTeacherToolUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EnterpriseTeacherToolUpdated(properties), options);
  }

  /**
   * Filter Action
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Filter%20Action)
   *
   * Fired when a user applies a filter interaction anywhere on the platform. Use `filter_surface` to identify the page, `filter_type` to distinguish chip vs. search, and `filter_value` for the applied value.
   *
   * @param properties The event's properties (e.g. filter_input_type)
   * @param options Amplitude event options.
   */
  filterAction(
    properties: FilterActionProperties,
    options?: EventOptions,
  ) {
    return this.track(new FilterAction(properties), options);
  }

  /**
   * Image Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Image%20Added)
   *
   * An image was added to a Presentation Studio slide, either uploaded by the teacher or generated with AI. Excludes the automatic first-slide image and the plan-time prefetch, neither of which a teacher initiates.
   *
   * @param properties The event's properties (e.g. image_add_status)
   * @param options Amplitude event options.
   */
  imageAdded(
    properties?: ImageAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ImageAdded(properties), options);
  }

  /**
   * Image Exported
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Image%20Exported)
   *
   * When a teacher intentionally exports a generated image out of MagicSchool, either by downloading the file or copying it to clipboard.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  imageExported(
    properties: ImageExportedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ImageExported(properties), options);
  }

  /**
   * Image Gen Upgrade Action
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Image%20Gen%20Upgrade%20Action)
   *
   * This is triggered when a user clicks the "Upgrade" CTA after hitting their limits with image gen
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  imageGenUpgradeAction(
    properties: ImageGenUpgradeActionProperties,
    options?: EventOptions,
  ) {
    return this.track(new ImageGenUpgradeAction(properties), options);
  }

  /**
   * Image Reported
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Image%20Reported)
   *
   * Fire on submit and cancel inside the Report Image modal. This captures intent and outcome of reporting an image.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  imageReported(
    properties: ImageReportedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ImageReported(properties), options);
  }

  /**
   * Inspiration Gallery Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Inspiration%20Gallery%20Opened)
   *
   * Fires when a teacher clicks See all and the inspiration gallery modal opens on the standalone image generator.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  inspirationGalleryOpened(
    properties: InspirationGalleryOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InspirationGalleryOpened(properties), options);
  }

  /**
   * Inspiration Gallery Searched
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Inspiration%20Gallery%20Searched)
   *
   * Fires after a non-empty search query is sent in the inspiration gallery modal. Includes zero-result searches. Does not fire when the modal opens with an empty query.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  inspirationGallerySearched(
    properties: InspirationGallerySearchedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InspirationGallerySearched(properties), options);
  }

  /**
   * Inspiration Prompt Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Inspiration%20Prompt%20Applied)
   *
   * Fires when Generate similar succeeds: the gallery prompt is written into the image generator form and the modal closes.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  inspirationPromptApplied(
    properties: InspirationPromptAppliedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InspirationPromptApplied(properties), options);
  }

  /**
   * Internal Admin Demo Org Accessed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Demo%20Org%20Accessed)
   *
   * A Demo Org has been accessed through impersonation
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminDemoOrgAccessed(
    properties: InternalAdminDemoOrgAccessedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminDemoOrgAccessed(properties), options);
  }

  /**
   * Internal Admin Demo Org Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Demo%20Org%20Created)
   *
   * A Demo Org has been created
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminDemoOrgCreated(
    properties: InternalAdminDemoOrgCreatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminDemoOrgCreated(properties), options);
  }

  /**
   * Internal Admin Demo Org Creation Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Demo%20Org%20Creation%20Started)
   *
   * A user clicks on the create Demo Org button to start the creation process
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminDemoOrgCreationStarted(
    properties?: InternalAdminDemoOrgCreationStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminDemoOrgCreationStarted(properties), options);
  }

  /**
   * Internal Admin Demo Org Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Demo%20Org%20Deleted)
   *
   * The deletion of a Demo Org has been confirmed bu an user.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminDemoOrgDeleted(
    properties: InternalAdminDemoOrgDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminDemoOrgDeleted(properties), options);
  }

  /**
   * Internal Admin Demo Org Feature Settings Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Demo%20Org%20Feature%20Settings%20Updated)
   *
   * An admin clicks a toggle for an organization feature in the 3 dot menu on an organization's 'Tool Access' page.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminDemoOrgFeatureSettingsUpdated(
    properties: InternalAdminDemoOrgFeatureSettingsUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminDemoOrgFeatureSettingsUpdated(properties), options);
  }

  /**
   * Internal Admin Demo Org Tool Access Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Demo%20Org%20Tool%20Access%20Updated)
   *
   * An Admin clicks a toggle from the Tool Access page for a Demo Organization.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminDemoOrgToolAccessUpdated(
    properties: InternalAdminDemoOrgToolAccessUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminDemoOrgToolAccessUpdated(properties), options);
  }

  /**
   * Internal Admin Organization Bulk Actions Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Organization%20Bulk%20Actions%20Opened)
   *
   * An admin clicks on 'Bulk Actions' from the More Options panel when viewing an Organization's menu.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminOrganizationBulkActionsOpened(
    properties: InternalAdminOrganizationBulkActionsOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminOrganizationBulkActionsOpened(properties), options);
  }

  /**
   * Internal Admin Organization Feature Settings Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Organization%20Feature%20Settings%20Updated)
   *
   * An admin clicks a toggle for an organization feature in the 3 dot menu on an organization's 'Tool Access' page.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminOrganizationFeatureSettingsUpdated(
    properties: InternalAdminOrganizationFeatureSettingsUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminOrganizationFeatureSettingsUpdated(properties), options);
  }

  /**
   * Internal Admin Organization Integrations Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Organization%20Integrations%20Opened)
   *
   * An admin clicks on 'Integrations' from the More Options panel when viewing an Organization's menu.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminOrganizationIntegrationsOpened(
    properties: InternalAdminOrganizationIntegrationsOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminOrganizationIntegrationsOpened(properties), options);
  }

  /**
   * Internal Admin Organization Notes Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Organization%20Notes%20Opened)
   *
   * An admin clicks on 'Org Notes' from the More Options panel when viewing an Organization's menu.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminOrganizationNotesOpened(
    properties: InternalAdminOrganizationNotesOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminOrganizationNotesOpened(properties), options);
  }

  /**
   * Internal Admin Organization Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Organization%20Opened)
   *
   * An admin clicks on an organization from the Organizations page.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminOrganizationOpened(
    properties: InternalAdminOrganizationOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminOrganizationOpened(properties), options);
  }

  /**
   * Internal Admin Organization Reporting Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Organization%20Reporting%20Opened)
   *
   * An admin clicks on 'Reporting' from the More Options panel when viewing and Organization's menu.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminOrganizationReportingOpened(
    properties: InternalAdminOrganizationReportingOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminOrganizationReportingOpened(properties), options);
  }

  /**
   * Internal Admin Organization Sync History Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Organization%20Sync%20History%20Opened)
   *
   * An admin clicks on 'View all syncs' from the More Options panel when viewing an Organization's menu.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminOrganizationSyncHistoryOpened(
    properties: InternalAdminOrganizationSyncHistoryOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminOrganizationSyncHistoryOpened(properties), options);
  }

  /**
   * Internal Admin Organization Tool Access Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Organization%20Tool%20Access%20Opened)
   *
   * An admin clicks on 'Tool Access' from the More Options panel when viewing an Organization's menu.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminOrganizationToolAccessOpened(
    properties: InternalAdminOrganizationToolAccessOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminOrganizationToolAccessOpened(properties), options);
  }

  /**
   * Internal Admin Organization Tool Access Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Organization%20Tool%20Access%20Updated)
   *
   * An Admin clicks a toggle from the Tool Access page for an Organization. Fires for the MagicSchool Student toggle upon confirmation or cancel.
   *
   * Use the event to distinguish confirmed access changes from cancelled toggle actions with tool_access_status, and compare enabled versus disabled outcomes with new_access_type. The organization_status property can be used to analyze access-management activity by organization state.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminOrganizationToolAccessUpdated(
    properties: InternalAdminOrganizationToolAccessUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminOrganizationToolAccessUpdated(properties), options);
  }

  /**
   * Internal Admin Organization Users Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Organization%20Users%20Opened)
   *
   * An admin clicks on 'Users' from the More Options panel when viewing an Organization's menu.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminOrganizationUsersOpened(
    properties: InternalAdminOrganizationUsersOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminOrganizationUsersOpened(properties), options);
  }

  /**
   * Internal Admin Reset Password Email Sent
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Reset%20Password%20Email%20Sent)
   *
   * An admin clicks the purple 'Send Reset Email' button from the 3 dot dropdown within the user's menu.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminResetPasswordEmailSent(
    properties: InternalAdminResetPasswordEmailSentProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminResetPasswordEmailSent(properties), options);
  }

  /**
   * Internal Admin User Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20User%20Deleted)
   *
   * An admin deletes a user from the 'All Users' page with the 3 dot actions menu or in the user's menu. Event fires on click of red 'Delete Account' button.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminUserDeleted(
    properties: InternalAdminUserDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminUserDeleted(properties), options);
  }

  /**
   * Internal Admin User Event Syncs Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20User%20Event%20Syncs%20Opened)
   *
   * An admin clicks Sync Events in a user's menu.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminUserEventSyncsOpened(
    properties: InternalAdminUserEventSyncsOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminUserEventSyncsOpened(properties), options);
  }

  /**
   * Internal Admin User Feature Access Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20User%20Feature%20Access%20Updated)
   *
   * An admin updates a user's feature access from the 'All Users' page with the 3 dot actions menu or in the user's menu. Fires when a toggle is flipped.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminUserFeatureAccessUpdated(
    properties: InternalAdminUserFeatureAccessUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminUserFeatureAccessUpdated(properties), options);
  }

  /**
   * Internal Admin User Impersonated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20User%20Impersonated)
   *
   * An admin impersonates a user from the 'All Users' page with the 3 dot actions menu or in the user's menu. Event fires when admin clicks 'Impersonate User'.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminUserImpersonated(
    properties: InternalAdminUserImpersonatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminUserImpersonated(properties), options);
  }

  /**
   * Internal Admin User Migrated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20User%20Migrated)
   *
   * An admin clicks on purple 'Migrate User' button after finding both a source and target email for the migration.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminUserMigrated(
    properties: InternalAdminUserMigratedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminUserMigrated(properties), options);
  }

  /**
   * Internal Admin User Migration Searched
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20User%20Migration%20Searched)
   *
   * An admin clicks the search button for either the source email or target email on the Migrate User page.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminUserMigrationSearched(
    properties: InternalAdminUserMigrationSearchedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminUserMigrationSearched(properties), options);
  }

  /**
   * Internal Admin User Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20User%20Removed)
   *
   * An admin removes a user from an organization from the 'All Users' page with the 3 dot actions menu. Fires on confirmation of purple 'Remove User' button.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminUserRemoved(
    properties: InternalAdminUserRemovedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminUserRemoved(properties), options);
  }

  /**
   * Internal Admin User Role Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20User%20Role%20Updated)
   *
   * An admin modifies a user's role from the All Users page from either the 3 dot actions menu or in the user's menu. Event fires when the red 'Update Role' button is clicked.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminUserRoleUpdated(
    properties: InternalAdminUserRoleUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalAdminUserRoleUpdated(properties), options);
  }

  /**
   * Manual SSO Sync Triggered
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Manual%20SSO%20Sync%20Triggered)
   *
   * Triggered by org admin when they initate a manual sync of user data from their SSO integration.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  manualSsoSyncTriggered(
    properties: ManualSsoSyncTriggeredProperties,
    options?: EventOptions,
  ) {
    return this.track(new ManualSsoSyncTriggered(properties), options);
  }

  /**
   * Moderation Settings Left Unsaved
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Moderation%20Settings%20Left%20Unsaved)
   *
   * The org admin left the moderation settings pages (categories, keywords, alerting, or denied topics) while there were unsaved buffered edits.
   *
   * @param properties The event's properties (e.g. moderation_settings_path)
   * @param options Amplitude event options.
   */
  moderationSettingsLeftUnsaved(
    properties?: ModerationSettingsLeftUnsavedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ModerationSettingsLeftUnsaved(properties), options);
  }

  /**
   * Module Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Module%20Removed)
   *
   * This event is triggered when a user removes a module from the homepage. It captures the action of dismissing or removing a module.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  moduleRemoved(
    properties: ModuleRemovedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ModuleRemoved(properties), options);
  }

  /**
   * Navigation Action
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Navigation%20Action)
   *
   * Captures user interactions that involve navigating to a new page route within the application.
   *
   * Note: should only be used when additional properties beyond the default Amplitude "Page Viewed" event are needed (e.g., navigation_surface).
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  navigationAction(
    properties: NavigationActionProperties,
    options?: EventOptions,
  ) {
    return this.track(new NavigationAction(properties), options);
  }

  /**
   * Onboarding Step Interaction
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Onboarding%20Step%20Interaction)
   *
   * Captures ProfileBuilder next/back step transitions.  Helps deduce user drop-off points for users who don't complete on-boarding.
   *
   * @param properties The event's properties (e.g. has_prior_completed_profile)
   * @param options Amplitude event options.
   */
  onboardingStepInteraction(
    properties: OnboardingStepInteractionProperties,
    options?: EventOptions,
  ) {
    return this.track(new OnboardingStepInteraction(properties), options);
  }

  /**
   * Org Customization Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Org%20Customization%20Saved)
   *
   * This event is triggered when a user successfully saves a welcome message within the application. It captures the action of finalizing and storing the customized welcome content.
   *
   * Owner: brian.bouchard@magicschool.ai
   *
   * @param properties The event's properties (e.g. has_links)
   * @param options Amplitude event options.
   */
  orgCustomizationSaved(
    properties: OrgCustomizationSavedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OrgCustomizationSaved(properties), options);
  }

  /**
   * Presentation Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Presentation%20Closed)
   *
   * The Studio panel stopped showing a deck: closed with its own close button, dismissed, or replaced by another artifact. time_open_ms is how long it was open. Mirrors Document Closed.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  presentationClosed(
    properties: PresentationClosedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PresentationClosed(properties), options);
  }

  /**
   * Presentation Exported
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Presentation%20Exported)
   *
   * A teacher exported a Presentation Studio deck. One event per attempt, carrying the export target (PPTX download or Google Slides) and whether it succeeded.
   *
   * @param properties The event's properties (e.g. org_id)
   * @param options Amplitude event options.
   */
  presentationExported(
    properties?: PresentationExportedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PresentationExported(properties), options);
  }

  /**
   * Presentation Generated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Presentation%20Generated)
   *
   * Presentation Studio deck generation reached a terminal state. One event per deck, with a status covering success, partial success, both failure modes, and a user stop. Carries wall-clock duration, so this is the event the staged rollout gate reads for error rate and latency.
   *
   * @param properties The event's properties (e.g. generation_duration_ms)
   * @param options Amplitude event options.
   */
  presentationGenerated(
    properties: PresentationGeneratedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PresentationGenerated(properties), options);
  }

  /**
   * Presentation Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Presentation%20Opened)
   *
   * The Studio panel opened on a Presentation Studio deck, or switched to it from another artifact. Reopening the deck already shown reports nothing. Mirrors Document Opened so the document and deck funnels line up.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  presentationOpened(
    properties: PresentationOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PresentationOpened(properties), options);
  }

  /**
   * Presentation Refined
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Presentation%20Refined)
   *
   * A teacher refined a Presentation Studio slide or the whole deck with AI. Excludes the automatic blank-slide repair, which retries up to three times per slide and is not a user action.
   *
   * @param properties The event's properties (e.g. history_action)
   * @param options Amplitude event options.
   */
  presentationRefined(
    properties?: PresentationRefinedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PresentationRefined(properties), options);
  }

  /**
   * Presentation Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Presentation%20Requested)
   *
   * A teacher submitted a presentation brief and deck generation started. Fires once per new deck, when the outline request is sent. Does not fire when a saved deck is reopened, and does not fire on the internal plan retry.
   *
   * @param properties The event's properties (e.g. language)
   * @param options Amplitude event options.
   */
  presentationRequested(
    properties?: PresentationRequestedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PresentationRequested(properties), options);
  }

  /**
   * Printable Exported
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Printable%20Exported)
   *
   * A teacher printed or exported a printables document from Studio. The beta's primary metric is the share of generated printables that reach this event.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  printableExported(
    properties: PrintableExportedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PrintableExported(properties), options);
  }

  /**
   * Printable Revised
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Printable%20Revised)
   *
   * A teacher revised a printable page from the image's Edit button and the revised image landed on the page. Count per document_id for revisions per printable.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  printableRevised(
    properties: PrintableRevisedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PrintableRevised(properties), options);
  }

  /**
   * Profile Update Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Profile%20Update%20Closed)
   *
   * Modal successfully dismissed.  X button, ESC, outside-click.  Only triggered on non-blocking modals.
   *
   * @param properties The event's properties (e.g. hard_dismissals_used)
   * @param options Amplitude event options.
   */
  profileUpdateClosed(
    properties: ProfileUpdateClosedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProfileUpdateClosed(properties), options);
  }

  /**
   * Profile Update Impression
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Profile%20Update%20Impression)
   *
   * This event represents the system displaying a profile update interface to the user. It is triggered each time the profile update screen or modal is presented within the application.
   *
   * @param properties The event's properties (e.g. has_prior_completed_profile)
   * @param options Amplitude event options.
   */
  profileUpdateImpression(
    properties: ProfileUpdateImpressionProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProfileUpdateImpression(properties), options);
  }

  /**
   * Profile Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Profile%20Updated)
   *
   * Any successful profile update save - modal confirm, /profile page, ProfileBuilder, etc.
   *
   * @param properties The event's properties (e.g. city)
   * @param options Amplitude event options.
   */
  profileUpdated(
    properties: ProfileUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProfileUpdated(properties), options);
  }

  /**
   * Prompt Starter Impression
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Prompt%20Starter%20Impression)
   *
   * Fires when the prompt starter chip becomes visible to the user on a tracked surface
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  promptStarterImpression(
    properties: PromptStarterImpressionProperties,
    options?: EventOptions,
  ) {
    return this.track(new PromptStarterImpression(properties), options);
  }

  /**
   * Prompt Starter Menu Item Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Prompt%20Starter%20Menu%20Item%20Applied)
   *
   * Fires when a user selects a prompt from the expanded menu, applying it to the input
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  promptStarterMenuItemApplied(
    properties: PromptStarterMenuItemAppliedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PromptStarterMenuItemApplied(properties), options);
  }

  /**
   * Prompt Starter Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Prompt%20Starter%20Menu%20Opened)
   *
   * Fires when a user clicks the prompt starter chip, expanding the prompt menu
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  promptStarterMenuOpened(
    properties: PromptStarterMenuOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PromptStarterMenuOpened(properties), options);
  }

  /**
   * Recommendations Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Recommendations%20Clicked)
   *
   * This event records when a user clicks on a recommended tool within the Home team’s recommendation module. It is triggered immediately upon the user's click interaction on any recommendation displayed on the home screen.
   *
   * @param properties The event's properties (e.g. impression_id)
   * @param options Amplitude event options.
   */
  recommendationsClicked(
    properties: RecommendationsClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RecommendationsClicked(properties), options);
  }

  /**
   * Recommendations Impression
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Recommendations%20Impression)
   *
   * This event captures each instance when a user views a list of tool recommendations.
   *
   * @param properties The event's properties (e.g. grade_band)
   * @param options Amplitude event options.
   */
  recommendationsImpression(
    properties: RecommendationsImpressionProperties,
    options?: EventOptions,
  ) {
    return this.track(new RecommendationsImpression(properties), options);
  }

  /**
   * Resource File Upload Completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Resource%20File%20Upload%20Completed)
   *
   * This event represents the completion of a user uploading a file to their resource library. It is triggered immediately after the file upload process finishes successfully.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  resourceFileUploadCompleted(
    properties: ResourceFileUploadCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ResourceFileUploadCompleted(properties), options);
  }

  /**
   * Resource File Upload Initiated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Resource%20File%20Upload%20Initiated)
   *
   * This event represents the user action of starting to upload a resource file to their resource library. It is triggered at the moment the upload process is initiated.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  resourceFileUploadInitiated(
    properties: ResourceFileUploadInitiatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ResourceFileUploadInitiated(properties), options);
  }

  /**
   * Resource Library Filtered
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Resource%20Library%20Filtered)
   *
   * This event captures when a user applies one or more filters within the Resource Library to refine available teaching materials. It is triggered each time the filter criteria are updated and submitted.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  resourceLibraryFiltered(
    properties: ResourceLibraryFilteredProperties,
    options?: EventOptions,
  ) {
    return this.track(new ResourceLibraryFiltered(properties), options);
  }

  /**
   * Resource Library Searched
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Resource%20Library%20Searched)
   *
   * This event represents a user performing a search within the Resource Library. It is triggered each time a search query is submitted to find specific resources.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  resourceLibrarySearched(
    properties: ResourceLibrarySearchedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ResourceLibrarySearched(properties), options);
  }

  /**
   * Resource Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Resource%20Opened)
   *
   * This event is triggered when a user views a specific resource from their library. The event occurs immediately upon the resource being clicked from the My Resources page.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  resourceOpened(
    properties: ResourceOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ResourceOpened(properties), options);
  }

  /**
   * Resource Preview Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Resource%20Preview%20Opened)
   *
   * Fired when the user opens an inline preview for an artifact, upload, or image within the 'My Resources' page.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  resourcePreviewOpened(
    properties: ResourcePreviewOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ResourcePreviewOpened(properties), options);
  }

  /**
   * Resource Referenced
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Resource%20Referenced)
   *
   * This event is triggered when a user links a library resource for reference in a chat generation.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  resourceReferenced(
    properties: ResourceReferencedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ResourceReferenced(properties), options);
  }

  /**
   * Resource Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Resource%20Removed)
   *
   * This event represents the action of a user removing a resource from their resource library.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  resourceRemoved(
    properties: ResourceRemovedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ResourceRemoved(properties), options);
  }

  /**
   * Resource Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Resource%20Saved)
   *
   * This event represents the action of a user saving a resource to their resource library.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  resourceSaved(
    properties: ResourceSavedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ResourceSaved(properties), options);
  }

  /**
   * SSO Integration Guide Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/SSO%20Integration%20Guide%20Opened)
   *
   * This event is triggered when an org admin views our SSO integregration guide PDF.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  ssoIntegrationGuideOpened(
    properties: SsoIntegrationGuideOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SsoIntegrationGuideOpened(properties), options);
  }

  /**
   * Start Quiz Generated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Start%20Quiz%20Generated)
   *
   * Fires when a user attempts to generate a quiz, tracking validation flags and # of questions selected
   *
   * @param properties The event's properties (e.g. grade_level_validation_failed)
   * @param options Amplitude event options.
   */
  startQuizGenerated(
    properties: StartQuizGeneratedProperties,
    options?: EventOptions,
  ) {
    return this.track(new StartQuizGenerated(properties), options);
  }

  /**
   * Subscription: Subscribe Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Subscription%3A%20Subscribe%20Button%20Clicked)
   *
   * This event tracks when a user clicks on the Subscribe button to finish an ongoing trial
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  subscriptionSubscribeButtonClicked(
    properties?: SubscriptionSubscribeButtonClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SubscriptionSubscribeButtonClicked(properties), options);
  }

  /**
   * Table Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Table%20Edited)
   *
   * A teacher restructured a table in a Studio document from its controls: rows or columns added, removed, moved, or resized. A drag that adds several rows is one event.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  tableEdited(
    properties: TableEditedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableEdited(properties), options);
  }

  /**
   * Table Filtered
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Table%20Filtered)
   *
   * Fires when a column filter is applied or changed.
   *
   * @param properties The event's properties (e.g. filter_column)
   * @param options Amplitude event options.
   */
  tableFiltered(
    properties: TableFilteredProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableFiltered(properties), options);
  }

  /**
   * Table Filters Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Table%20Filters%20Cleared)
   *
   * Fires when all active filters are cleared at once.
   *
   * @param properties The event's properties (e.g. table_name)
   * @param options Amplitude event options.
   */
  tableFiltersCleared(
    properties: TableFiltersClearedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableFiltersCleared(properties), options);
  }

  /**
   * Table Paginated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Table%20Paginated)
   *
   * Fires when the user navigates to a different page or changes page size.
   *
   * @param properties The event's properties (e.g. page_number)
   * @param options Amplitude event options.
   */
  tablePaginated(
    properties: TablePaginatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TablePaginated(properties), options);
  }

  /**
   * Table Row Expansion Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Table%20Row%20Expansion%20Changed)
   *
   * Fires when the user expands or collapses a row to reveal or hide inline sub-content.
   *
   * @param properties The event's properties (e.g. row_expansion_action)
   * @param options Amplitude event options.
   */
  tableRowExpansionChanged(
    properties: TableRowExpansionChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableRowExpansionChanged(properties), options);
  }

  /**
   * Table Row Selection Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Table%20Row%20Selection%20Changed)
   *
   * Fires when the user selects or deselects one or more rows.
   *
   * @param properties The event's properties (e.g. selected_count)
   * @param options Amplitude event options.
   */
  tableRowSelectionChanged(
    properties: TableRowSelectionChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableRowSelectionChanged(properties), options);
  }

  /**
   * Table Searched
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Table%20Searched)
   *
   * Fires when the user types a search query in the DataGrid global search.
   *
   * @param properties The event's properties (e.g. search_term)
   * @param options Amplitude event options.
   */
  tableSearched(
    properties: TableSearchedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableSearched(properties), options);
  }

  /**
   * Table Sorted
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Table%20Sorted)
   *
   * Fires when the user sorts a DataGrid column.
   *
   * @param properties The event's properties (e.g. sort_column)
   * @param options Amplitude event options.
   */
  tableSorted(
    properties: TableSortedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableSorted(properties), options);
  }

  /**
   * Thread Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Thread%20Deleted)
   *
   * This event is triggered when a user deletes a thread from their history.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  threadDeleted(
    properties: ThreadDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ThreadDeleted(properties), options);
  }

  /**
   * Thread Favorite Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Thread%20Favorite%20Removed)
   *
   * Fires when the user un-stars a thread using the favorite toggle in the Chat History table.
   *
   * @param properties The event's properties (e.g. thread_id)
   * @param options Amplitude event options.
   */
  threadFavoriteRemoved(
    properties: ThreadFavoriteRemovedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ThreadFavoriteRemoved(properties), options);
  }

  /**
   * Thread Favorited
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Thread%20Favorited)
   *
   * Fires when the user stars a thread using the favorite toggle in the Chat History table.
   *
   * @param properties The event's properties (e.g. thread_id)
   * @param options Amplitude event options.
   */
  threadFavorited(
    properties: ThreadFavoritedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ThreadFavorited(properties), options);
  }

  /**
   * Thread Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Thread%20Opened)
   *
   * This even is triggered when a user opens a thread from their history.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  threadOpened(
    properties: ThreadOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ThreadOpened(properties), options);
  }

  /**
   * Thread Previewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Thread%20Previewed)
   *
   * Fires when the user opens the read-only preview drawer via the eye icon in the Chat History table.
   *
   * @param properties The event's properties (e.g. thread_id)
   * @param options Amplitude event options.
   */
  threadPreviewed(
    properties: ThreadPreviewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ThreadPreviewed(properties), options);
  }

  /**
   * Thread Sharing Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Thread%20Sharing%20Edited)
   *
   * Fires when the user changes the sharing access level in the sharing dialog (action menu → Edit Sharing Access → submit). Fires on successful access type change, not on copy-link or modal open.
   *
   * @param properties The event's properties (e.g. sharing_type)
   * @param options Amplitude event options.
   */
  threadSharingEdited(
    properties: ThreadSharingEditedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ThreadSharingEdited(properties), options);
  }

  /**
   * Thread Title Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Thread%20Title%20Edited)
   *
   * Fires when the user confirms a title update in the Edit Title modal (action menu → Edit Title → save button). Fires on successful save, not on modal open.
   *
   * @param properties The event's properties (e.g. thread_id)
   * @param options Amplitude event options.
   */
  threadTitleEdited(
    properties: ThreadTitleEditedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ThreadTitleEdited(properties), options);
  }

  /**
   * Tool Call Output Generated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Tool%20Call%20Output%20Generated)
   *
   * Tracks successful tool-call completions. Supplements existing Document Generated for non-document tool calls (e.g., email).
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  toolCallOutputGenerated(
    properties: ToolCallOutputGeneratedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ToolCallOutputGenerated(properties), options);
  }

  /**
   * Tool Card Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Tool%20Card%20Clicked)
   *
   * Fired when a user clicks a tool card to open the tool. Covers all surfaces where tool cards appear.
   *
   * @param properties The event's properties (e.g. active_filter_type)
   * @param options Amplitude event options.
   */
  toolCardClicked(
    properties: ToolCardClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ToolCardClicked(properties), options);
  }

  /**
   * Tool Favorite Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Tool%20Favorite%20Removed)
   *
   * This event represents a user action where a previously favorited tool is removed from their favorites list. It is triggered immediately when the user unfavorites a tool.
   *
   * @param properties The event's properties (e.g. favorite_surface)
   * @param options Amplitude event options.
   */
  toolFavoriteRemoved(
    properties: ToolFavoriteRemovedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ToolFavoriteRemoved(properties), options);
  }

  /**
   * Tool Favorited
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Tool%20Favorited)
   *
   * Fired when a user favorites a tool. Deprecates `MagicTools:AddFavorite`, adding surface context.
   *
   * @param properties The event's properties (e.g. favorite_surface)
   * @param options Amplitude event options.
   */
  toolFavorited(
    properties: ToolFavoritedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ToolFavorited(properties), options);
  }

  /**
   * Tool Sorted
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Tool%20Sorted)
   *
   * Captures when a user sorts tools within the teacher and student tools pages, triggered each time the sorting criteria for tools is changed by the user.
   *
   * @param properties The event's properties (e.g. sort_surface)
   * @param options Amplitude event options.
   */
  toolSorted(
    properties: ToolSortedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ToolSorted(properties), options);
  }

  /**
   * Tool Suggestion Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Tool%20Suggestion%20Clicked)
   *
   * A suggestion under a Raina response was tapped.
   *
   * @param properties The event's properties (e.g. chat_surface)
   * @param options Amplitude event options.
   */
  toolSuggestionClicked(
    properties: ToolSuggestionClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ToolSuggestionClicked(properties), options);
  }

  /**
   * Tool Suggestion Shown
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Tool%20Suggestion%20Shown)
   *
   * A suggestion rendered under a Raina response. suggestion_type separates today's follow-up suggestions from the future Try-this-as-a-tool pill.
   *
   * @param properties The event's properties (e.g. chat_surface)
   * @param options Amplitude event options.
   */
  toolSuggestionShown(
    properties: ToolSuggestionShownProperties,
    options?: EventOptions,
  ) {
    return this.track(new ToolSuggestionShown(properties), options);
  }

  /**
   * Tool View Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Tool%20View%20Edited)
   *
   * Fires when a list of tools is expanded/collapsed (e.g., show more, show less).
   *
   * @param properties The event's properties (e.g. tool_view_edit_action)
   * @param options Amplitude event options.
   */
  toolViewEdited(
    properties: ToolViewEditedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ToolViewEdited(properties), options);
  }

  /**
   * Toolbar Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Toolbar%20Menu%20Opened)
   *
   * A toolbar dropdown, colour picker, More menu, view mode menu or export menu opened in the Studio document editor or the slide text toolbar. Pair with Content Formatted for how often a menu opens and closes without a choice.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  toolbarMenuOpened(
    properties: ToolbarMenuOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ToolbarMenuOpened(properties), options);
  }

  /**
   * Usage Limit Impression
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Usage%20Limit%20Impression)
   *
   * When a user hits the usage limit of 75%, 80%, 90%, or 100%, a banner shows on chat inputs in tools and raina and on the tool form to show them their usage and how many generations remain.
   *
   * Use this event to measure weekly users reaching each usage gate, compare impressions across banner surfaces, and analyze conversion from a usage-limit gate to a paid upgrade within seven days. Filter or segment by usage_threshold and usage_banner_surface to distinguish the 75%, 80%, 90%, and 100% gates and the product surface where the banner appeared.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  usageLimitImpression(
    properties?: UsageLimitImpressionProperties,
    options?: EventOptions,
  ) {
    return this.track(new UsageLimitImpression(properties), options);
  }

  /**
   * User Org Role Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/User%20Org%20Role%20Updated)
   *
   * Triggered when an org admin changes the role of a user.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  userOrgRoleUpdated(
    properties: UserOrgRoleUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new UserOrgRoleUpdated(properties), options);
  }

  /**
   * User Site Role Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/User%20Site%20Role%20Updated)
   *
   * Triggered when an org admin changes a user's role/access within a site/institution.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  userSiteRoleUpdated(
    properties: UserSiteRoleUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new UserSiteRoleUpdated(properties), options);
  }

  /**
   * Video Played
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Video%20Played)
   *
   * This event records when a user initiates playback of a video.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  videoPlayed(
    properties: VideoPlayedProperties,
    options?: EventOptions,
  ) {
    return this.track(new VideoPlayed(properties), options);
  }

  /**
   * View Mode Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/View%20Mode%20Changed)
   *
   * A teacher switched the Studio document editor between Paged and Pageless. The temporary paged layout used while printing does not fire.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  viewModeChanged(
    properties: ViewModeChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewModeChanged(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
